/* tslint:disable */
/* eslint-disable */
/**
 * SpareBank 1 Finans Midt-Norge Banking API\"
 * SpareBank 1 Finans Midt-Norge API
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Account
 */
export interface Account {
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'providerName': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'ownerName': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'ownerLegalId': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'ownerCustomerId'?: string | null;
    /**
     * 
     * @type {AccountType}
     * @memberof Account
     */
    'accountType': AccountType;
    /**
     * 
     * @type {AccountStatus}
     * @memberof Account
     */
    'accountStatus': AccountStatus;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'interestRate': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'effectiveRate': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'bookedBalance': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'availableBalance': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'pendingPayoutAmount': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'creditLimit': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'balanceDue': string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'principalDate'?: string;
    /**
     * 
     * @type {Array<Entity>}
     * @memberof Account
     */
    'debtors'?: Array<Entity> | null;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Account
     */
    'endDate'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AccountStatus = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Suspended: 'SUSPENDED'
} as const;

export type AccountStatus = typeof AccountStatus[keyof typeof AccountStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const AccountType = {
    Factoring: 'FACTORING',
    InvoiceSale: 'INVOICE_SALE',
    Leasing: 'LEASING',
    Loan: 'LOAN',
    Other: 'OTHER'
} as const;

export type AccountType = typeof AccountType[keyof typeof AccountType];


/**
 * 
 * @export
 * @interface AddOnRequest
 */
export interface AddOnRequest {
    /**
     * 
     * @type {string}
     * @memberof AddOnRequest
     */
    'name': string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof AddOnRequest
     */
    'config': { [key: string]: object; };
}
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'id'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    'postalCode': number;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'addressLine1': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'addressLine2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'addressLine3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'countryCode': string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'country'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface Agreement
 */
export interface Agreement {
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'legalId': string;
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'name': string;
    /**
     * 
     * @type {AgreementType}
     * @memberof Agreement
     */
    'type': AgreementType;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Agreement
     */
    'metaData': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Agreement
     */
    'createdBy'?: string | null;
}


/**
 * 
 * @export
 * @interface AgreementMember
 */
export interface AgreementMember {
    /**
     * 
     * @type {string}
     * @memberof AgreementMember
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AgreementMember
     */
    'legalId': string;
    /**
     * 
     * @type {string}
     * @memberof AgreementMember
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AgreementMember
     */
    'email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AgreementMember
     */
    'scopes': Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AgreementType = {
    Corporate: 'CORPORATE',
    Individual: 'INDIVIDUAL'
} as const;

export type AgreementType = typeof AgreementType[keyof typeof AgreementType];


/**
 * 
 * @export
 * @interface ApiError
 */
export interface ApiError {
    /**
     * 
     * @type {string}
     * @memberof ApiError
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiError
     */
    'localizedMessage'?: string;
    /**
     * 
     * @type {Throwable}
     * @memberof ApiError
     */
    'cause'?: Throwable;
    /**
     * 
     * @type {Array<StackTraceElement>}
     * @memberof ApiError
     */
    'stackTrace'?: Array<StackTraceElement>;
    /**
     * 
     * @type {Array<Throwable>}
     * @memberof ApiError
     */
    'suppressed'?: Array<Throwable>;
    /**
     * 
     * @type {number}
     * @memberof ApiError
     */
    'httpStatus'?: number | null;
    /**
     * 
     * @type {ApiErrorCode}
     * @memberof ApiError
     */
    'code': ApiErrorCode;
    /**
     * 
     * @type {string}
     * @memberof ApiError
     */
    'description': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiError
     */
    'errors': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ApiError
     */
    'ref'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiErrorCode = {
    InsufficientPrivileges: 'InsufficientPrivileges',
    BadInput: 'BadInput',
    JsonError: 'JsonError',
    Unauthorized: 'Unauthorized',
    CustomerNotFound: 'CustomerNotFound',
    OrderNotFound: 'OrderNotFound',
    OrderAlreadyRegisteredInFloorplanning: 'OrderAlreadyRegisteredInFloorplanning',
    AccountOwnerVerificationFailed: 'AccountOwnerVerificationFailed',
    AccountnumberInvalid: 'AccountnumberInvalid',
    Unknown: 'Unknown'
} as const;

export type ApiErrorCode = typeof ApiErrorCode[keyof typeof ApiErrorCode];


/**
 * 
 * @export
 * @enum {string}
 */

export const ApiRole = {
    UserRead: 'USER_READ',
    UserWrite: 'USER_WRITE',
    AgreementCreate: 'AGREEMENT_CREATE',
    AgreementAdmin: 'AGREEMENT_ADMIN',
    AgreementRead: 'AGREEMENT_READ',
    AccountRead: 'ACCOUNT_READ',
    InvoiceRead: 'INVOICE_READ',
    InvoiceCreate: 'INVOICE_CREATE',
    SystemAdmin: 'SYSTEM_ADMIN',
    Anyone: 'ANYONE',
    OrderCreate: 'ORDER_CREATE',
    OrderRead: 'ORDER_READ'
} as const;

export type ApiRole = typeof ApiRole[keyof typeof ApiRole];


/**
 * 
 * @export
 * @interface AppNotification
 */
export interface AppNotification {
    /**
     * 
     * @type {string}
     * @memberof AppNotification
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AppNotification
     */
    'timestamp': string;
    /**
     * 
     * @type {string}
     * @memberof AppNotification
     */
    'payload': string;
    /**
     * 
     * @type {string}
     * @memberof AppNotification
     */
    'action': string;
    /**
     * 
     * @type {string}
     * @memberof AppNotification
     */
    'source': string;
    /**
     * 
     * @type {boolean}
     * @memberof AppNotification
     */
    'consumed': boolean;
}
/**
 * 
 * @export
 * @interface Attachment
 */
export interface Attachment {
    /**
     * 
     * @type {AttachmentType}
     * @memberof Attachment
     */
    'attachmentType': AttachmentType;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    'data': string;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    'fileExtension': string;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    'fileName': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const AttachmentType = {
    AgeDistributedBalanceList: 'AGE_DISTRIBUTED_BALANCE_LIST',
    InterimAccounts: 'INTERIM_ACCOUNTS',
    TaxReport: 'TAX_REPORT',
    Contract: 'CONTRACT'
} as const;

export type AttachmentType = typeof AttachmentType[keyof typeof AttachmentType];


/**
 * 
 * @export
 * @enum {string}
 */

export const AuthLevel = {
    None: 'NONE',
    Low: 'LOW',
    High: 'HIGH'
} as const;

export type AuthLevel = typeof AuthLevel[keyof typeof AuthLevel];


/**
 * 
 * @export
 * @enum {string}
 */

export const AuthProvider = {
    MobileAuth: 'MOBILE_AUTH',
    Signicat: 'SIGNICAT',
    AzureAd: 'AZURE_AD',
    Internal: 'INTERNAL',
    TietoEvry: 'TIETO_EVRY',
    Sbm: 'SBM',
    Bnbank: 'BNBANK',
    Altinn: 'ALTINN'
} as const;

export type AuthProvider = typeof AuthProvider[keyof typeof AuthProvider];


/**
 * 
 * @export
 * @interface AuthProviderResponse
 */
export interface AuthProviderResponse {
    /**
     * 
     * @type {AuthProvider}
     * @memberof AuthProviderResponse
     */
    'name': AuthProvider;
    /**
     * 
     * @type {string}
     * @memberof AuthProviderResponse
     */
    'loginUrl': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AuthProviderResponse
     */
    'requiredMetaData': Array<string>;
}


/**
 * 
 * @export
 * @interface BankConnection
 */
export interface BankConnection {
    /**
     * 
     * @type {string}
     * @memberof BankConnection
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BankConnection
     */
    'orgNo'?: string | null;
}
/**
 * 
 * @export
 * @interface Chronology
 */
export interface Chronology {
    /**
     * 
     * @type {DateTimeZone}
     * @memberof Chronology
     */
    'zone'?: DateTimeZone;
    /**
     * 
     * @type {number}
     * @memberof Chronology
     */
    'dateTimeMillis': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof Chronology
     */
    ''?: Array<number>;
}
/**
 * 
 * @export
 * @interface CompanyInfo
 */
export interface CompanyInfo {
    /**
     * 
     * @type {string}
     * @memberof CompanyInfo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CompanyInfo
     */
    'bankAccount'?: string | null;
}
/**
 * 
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'orgNo': string;
    /**
     * 
     * @type {Address}
     * @memberof Contact
     */
    'address'?: Address;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'source': string;
}
/**
 * 
 * @export
 * @interface ContactPerson
 */
export interface ContactPerson {
    /**
     * 
     * @type {string}
     * @memberof ContactPerson
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof ContactPerson
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof ContactPerson
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ContactPerson
     */
    'phone': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CreditOnboardingSource = {
    Ownerbank: 'OWNERBANK',
    Notownerbank: 'NOTOWNERBANK'
} as const;

export type CreditOnboardingSource = typeof CreditOnboardingSource[keyof typeof CreditOnboardingSource];


/**
 * 
 * @export
 * @interface CustomerNotification
 */
export interface CustomerNotification {
    /**
     * 
     * @type {string}
     * @memberof CustomerNotification
     */
    'id': string;
    /**
     * 
     * @type {CustomerNotificationType}
     * @memberof CustomerNotification
     */
    'type': CustomerNotificationType;
    /**
     * 
     * @type {CustomerNotificationChannel}
     * @memberof CustomerNotification
     */
    'channel': CustomerNotificationChannel;
    /**
     * 
     * @type {string}
     * @memberof CustomerNotification
     */
    'address': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CustomerNotificationChannel = {
    Sms: 'SMS',
    Email: 'EMAIL'
} as const;

export type CustomerNotificationChannel = typeof CustomerNotificationChannel[keyof typeof CustomerNotificationChannel];


/**
 * 
 * @export
 * @enum {string}
 */

export const CustomerNotificationType = {
    OrderCreated: 'ORDER_CREATED'
} as const;

export type CustomerNotificationType = typeof CustomerNotificationType[keyof typeof CustomerNotificationType];


/**
 * 
 * @export
 * @enum {string}
 */

export const CustomerType = {
    Personal: 'PERSONAL',
    Corporate: 'CORPORATE'
} as const;

export type CustomerType = typeof CustomerType[keyof typeof CustomerType];


/**
 * 
 * @export
 * @interface DateTime
 */
export interface DateTime {
    /**
     * 
     * @type {DateTimeZone}
     * @memberof DateTime
     */
    'zone'?: DateTimeZone;
    /**
     * 
     * @type {boolean}
     * @memberof DateTime
     */
    'supported': boolean;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    '': number;
    /**
     * 
     * @type {boolean}
     * @memberof DateTime
     */
    'after': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DateTime
     */
    'afterNow': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DateTime
     */
    'before': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DateTime
     */
    'beforeNow': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DateTime
     */
    'equal': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DateTime
     */
    'equalNow': boolean;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'era': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'centuryOfEra': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'yearOfEra': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'yearOfCentury': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'year': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'weekyear': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'monthOfYear': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'weekOfWeekyear': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'dayOfYear': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'dayOfMonth': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'dayOfWeek': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'hourOfDay': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'minuteOfDay': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'minuteOfHour': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'secondOfDay': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'secondOfMinute': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'millisOfDay': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'millisOfSecond': number;
    /**
     * 
     * @type {number}
     * @memberof DateTime
     */
    'millis': number;
    /**
     * 
     * @type {Chronology}
     * @memberof DateTime
     */
    'chronology'?: Chronology;
}
/**
 * 
 * @export
 * @interface DateTimeZone
 */
export interface DateTimeZone {
    /**
     * 
     * @type {string}
     * @memberof DateTimeZone
     */
    'iD'?: string;
    /**
     * 
     * @type {string}
     * @memberof DateTimeZone
     */
    'nameKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof DateTimeZone
     */
    'shortName'?: string;
    /**
     * 
     * @type {string}
     * @memberof DateTimeZone
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof DateTimeZone
     */
    'offset': number;
    /**
     * 
     * @type {boolean}
     * @memberof DateTimeZone
     */
    'standardOffset': boolean;
    /**
     * 
     * @type {number}
     * @memberof DateTimeZone
     */
    'offsetFromLocal': number;
    /**
     * 
     * @type {number}
     * @memberof DateTimeZone
     */
    'millisKeepLocal': number;
    /**
     * 
     * @type {boolean}
     * @memberof DateTimeZone
     */
    'localDateTimeGap': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DateTimeZone
     */
    'fixed': boolean;
}
/**
 * 
 * @export
 * @interface Dealer
 */
export interface Dealer {
    /**
     * 
     * @type {string}
     * @memberof Dealer
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof Dealer
     */
    'dealerNumber': number;
    /**
     * 
     * @type {string}
     * @memberof Dealer
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Dealer
     */
    'alias': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Dealer
     */
    'dealerGroups': Array<string>;
}
/**
 * 
 * @export
 * @interface Debtor
 */
export interface Debtor {
    /**
     * 
     * @type {string}
     * @memberof Debtor
     */
    'orgNo': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const Deliverables = {
    Products: 'PRODUCTS',
    Projects: 'PROJECTS',
    Services: 'SERVICES',
    Other: 'OTHER'
} as const;

export type Deliverables = typeof Deliverables[keyof typeof Deliverables];


/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'name': string;
    /**
     * 
     * @type {DocumentType}
     * @memberof Document
     */
    'type': DocumentType;
    /**
     * 
     * @type {File}
     * @memberof Document
     */
    'content'?: File | null;
    /**
     * 
     * @type {boolean}
     * @memberof Document
     */
    'received': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Document
     */
    'signed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Document
     */
    'signingMandatory': boolean;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    'signedBy'?: string | null;
}


/**
 * 
 * @export
 * @interface DocumentSummary
 */
export interface DocumentSummary {
    /**
     * 
     * @type {string}
     * @memberof DocumentSummary
     */
    'organizationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentSummary
     */
    'accountNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentSummary
     */
    'sellerCompany'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DocumentType = {
    Contract: 'CONTRACT',
    StartRent: 'START_RENT',
    UploadedDocument: 'UPLOADED_DOCUMENT',
    Other: 'OTHER'
} as const;

export type DocumentType = typeof DocumentType[keyof typeof DocumentType];


/**
 * 
 * @export
 * @interface Entity
 */
export interface Entity {
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'legalId': string;
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'contactName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'contactEmail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'contactPhone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Entity
     */
    'phone': string;
    /**
     * 
     * @type {Address}
     * @memberof Entity
     */
    'address'?: Address;
}
/**
 * 
 * @export
 * @interface ExtraPaymentInvoice
 */
export interface ExtraPaymentInvoice {
    /**
     * 
     * @type {string}
     * @memberof ExtraPaymentInvoice
     */
    'accountId': string;
    /**
     * 
     * @type {string}
     * @memberof ExtraPaymentInvoice
     */
    'amount': string;
    /**
     * 
     * @type {PrepaymentEffect}
     * @memberof ExtraPaymentInvoice
     */
    'prepaymentEffect': PrepaymentEffect;
}


/**
 * 
 * @export
 * @interface FinancedObject
 */
export interface FinancedObject {
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'productCategory'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FinancedObject
     */
    'productCategoryCode'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'productCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'gtin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'brand'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'merchantItemUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'productImageUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'registrationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FinancedObject
     */
    'serialNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface GeneralSettings
 */
export interface GeneralSettings {
    /**
     * 
     * @type {string}
     * @memberof GeneralSettings
     */
    'alias': string;
}
/**
 * 
 * @export
 * @interface GetOtpRequest
 */
export interface GetOtpRequest {
    /**
     * 
     * @type {string}
     * @memberof GetOtpRequest
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOtpRequest
     */
    'recipient': string;
    /**
     * 
     * @type {IdentifierType}
     * @memberof GetOtpRequest
     */
    'recipientType': IdentifierType;
}


/**
 * 
 * @export
 * @interface Hook
 */
export interface Hook {
    /**
     * 
     * @type {string}
     * @memberof Hook
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Hook
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof Hook
     */
    'type': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const IdentifierType = {
    Email: 'EMAIL',
    Phone: 'PHONE',
    App: 'APP',
    Ssn: 'SSN',
    InternalId: 'INTERNAL_ID'
} as const;

export type IdentifierType = typeof IdentifierType[keyof typeof IdentifierType];


/**
 * 
 * @export
 * @interface IncomingPayment
 */
export interface IncomingPayment {
    /**
     * 
     * @type {string}
     * @memberof IncomingPayment
     */
    'amount': string;
    /**
     * 
     * @type {string}
     * @memberof IncomingPayment
     */
    'dueDate': string;
    /**
     * 
     * @type {string}
     * @memberof IncomingPayment
     */
    'fees': string;
    /**
     * 
     * @type {string}
     * @memberof IncomingPayment
     */
    'remainingBalance': string;
    /**
     * 
     * @type {string}
     * @memberof IncomingPayment
     */
    'interest': string;
}
/**
 * 
 * @export
 * @interface Invite
 */
export interface Invite {
    /**
     * 
     * @type {string}
     * @memberof Invite
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Invite
     */
    'email': string;
    /**
     * 
     * @type {ApiRole}
     * @memberof Invite
     */
    'role': ApiRole;
    /**
     * 
     * @type {string}
     * @memberof Invite
     */
    'status': string;
}


/**
 * 
 * @export
 * @interface Invoice
 */
export interface Invoice {
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'invoiceId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'initialInvoiceId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    'invoiceNo'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'creditorRef'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'totalAmount': string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'restAmount'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'accountName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'dueDate': string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'invoiceDate': string;
    /**
     * 
     * @type {Entity}
     * @memberof Invoice
     */
    'debtor'?: Entity;
    /**
     * 
     * @type {Entity}
     * @memberof Invoice
     */
    'creditor'?: Entity;
    /**
     * 
     * @type {Array<string>}
     * @memberof Invoice
     */
    'comments': Array<string>;
    /**
     * 
     * @type {InvoiceStatus}
     * @memberof Invoice
     */
    'status': InvoiceStatus;
    /**
     * 
     * @type {InvoiceSource}
     * @memberof Invoice
     */
    'invoiceSource': InvoiceSource;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'cid': string;
    /**
     * 
     * @type {InvoiceDoumentType}
     * @memberof Invoice
     */
    'documentType': InvoiceDoumentType;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'invoiceDocumentUrl': string;
    /**
     * 
     * @type {Array<InvoiceLine>}
     * @memberof Invoice
     */
    'invoiceLines'?: Array<InvoiceLine> | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'priceOffer'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'purchasePrice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {InvoicePaymentStatus}
     * @memberof Invoice
     */
    'paymentStatus'?: InvoicePaymentStatus;
    /**
     * 
     * @type {boolean}
     * @memberof Invoice
     */
    'creditNote': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Invoice
     */
    'termination': boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const InvoiceDoumentType = {
    Ehf: 'EHF',
    Vipps: 'VIPPS',
    Einvoice: 'EINVOICE',
    Pdf: 'PDF',
    Mail: 'MAIL'
} as const;

export type InvoiceDoumentType = typeof InvoiceDoumentType[keyof typeof InvoiceDoumentType];


/**
 * 
 * @export
 * @interface InvoiceLine
 */
export interface InvoiceLine {
    /**
     * 
     * @type {number}
     * @memberof InvoiceLine
     */
    'lineNumber': number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    'lineType': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceLine
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    'vat': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    'amount': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    'amountIncVat': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    'minAmountToPay': string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    'fromDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceLine
     */
    'toDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceLine
     */
    'termNo': number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const InvoicePaymentStatus = {
    Open: 'OPEN',
    Expired: 'EXPIRED',
    Paid: 'PAID',
    InCollection: 'IN_COLLECTION'
} as const;

export type InvoicePaymentStatus = typeof InvoicePaymentStatus[keyof typeof InvoicePaymentStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const InvoiceSource = {
    Netbank: 'NETBANK',
    Erp: 'ERP',
    ManualSale: 'MANUAL_SALE'
} as const;

export type InvoiceSource = typeof InvoiceSource[keyof typeof InvoiceSource];


/**
 * 
 * @export
 * @enum {string}
 */

export const InvoiceStatus = {
    ProcessingFile: 'PROCESSING_FILE',
    PendingUpload: 'PENDING_UPLOAD',
    UploadedFlow: 'UPLOADED_FLOW',
    PendingApproval: 'PENDING_APPROVAL',
    Approved: 'APPROVED',
    Administered: 'ADMINISTERED',
    Rejected: 'REJECTED',
    Sold: 'SOLD',
    Error: 'ERROR',
    Cancelled: 'CANCELLED'
} as const;

export type InvoiceStatus = typeof InvoiceStatus[keyof typeof InvoiceStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const InvoicingType = {
    Advance: 'ADVANCE',
    Arrears: 'ARREARS',
    Both: 'BOTH',
    Null: 'NULL'
} as const;

export type InvoicingType = typeof InvoicingType[keyof typeof InvoicingType];


/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {AuthProvider}
     * @memberof LoginRequest
     */
    'authProvider': AuthProvider;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'codeVerifier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'redirectUri'?: string | null;
}


/**
 * 
 * @export
 * @interface MerchantData
 */
export interface MerchantData {
    /**
     * 
     * @type {string}
     * @memberof MerchantData
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MerchantData
     */
    'name': string;
    /**
     * 
     * @type {MerchantTheme}
     * @memberof MerchantData
     */
    'theme': MerchantTheme;
    /**
     * 
     * @type {AuthLevel}
     * @memberof MerchantData
     */
    'requiredAuthLevel': AuthLevel;
    /**
     * 
     * @type {Array<ProductType>}
     * @memberof MerchantData
     */
    'products': Array<ProductType>;
}


/**
 * 
 * @export
 * @interface MerchantTheme
 */
export interface MerchantTheme {
    /**
     * 
     * @type {string}
     * @memberof MerchantTheme
     */
    'logoUrl': string;
    /**
     * 
     * @type {string}
     * @memberof MerchantTheme
     */
    'primaryColor': string;
    /**
     * 
     * @type {string}
     * @memberof MerchantTheme
     */
    'secondaryColor': string;
    /**
     * 
     * @type {number}
     * @memberof MerchantTheme
     */
    'buttonRadius': number;
    /**
     * 
     * @type {string}
     * @memberof MerchantTheme
     */
    'textColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MerchantTheme
     */
    'buttonTextColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MerchantTheme
     */
    'secondaryTextColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MerchantTheme
     */
    'surfaceDefaultColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MerchantTheme
     */
    'surfaceContrastColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MerchantTheme
     */
    'surfaceMutedColor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MerchantTheme
     */
    'fontFamily'?: string | null;
    /**
     * 
     * @type {ThemeIcons}
     * @memberof MerchantTheme
     */
    'icons'?: ThemeIcons;
}
/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface OauthSession
 */
export interface OauthSession {
    /**
     * 
     * @type {string}
     * @memberof OauthSession
     */
    'clientId': string;
    /**
     * 
     * @type {string}
     * @memberof OauthSession
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {OauthStage}
     * @memberof OauthSession
     */
    'stage': OauthStage;
    /**
     * 
     * @type {string}
     * @memberof OauthSession
     */
    'nextUri'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OauthSession
     */
    'scopes': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof OauthSession
     */
    'acr_values'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OauthSession
     */
    'requestedAudience'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof OauthSession
     */
    'canSkipConsent': boolean;
    /**
     * 
     * @type {string}
     * @memberof OauthSession
     */
    'loginHint'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OauthStage = {
    Auth: 'AUTH',
    Consent: 'CONSENT',
    Redirect: 'REDIRECT'
} as const;

export type OauthStage = typeof OauthStage[keyof typeof OauthStage];


/**
 * 
 * @export
 * @interface OauthState
 */
export interface OauthState {
    /**
     * 
     * @type {OauthStage}
     * @memberof OauthState
     */
    'stage': OauthStage;
    /**
     * 
     * @type {string}
     * @memberof OauthState
     */
    'redirectUri'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OnboardingStatus = {
    Pending: 'PENDING',
    Submitted: 'SUBMITTED',
    Rejected: 'REJECTED',
    Approved: 'APPROVED'
} as const;

export type OnboardingStatus = typeof OnboardingStatus[keyof typeof OnboardingStatus];


/**
 * 
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'orderNumber'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'agreementId': string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'dealerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'externalId': string;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'internalId'?: number | null;
    /**
     * 
     * @type {OrderStatus}
     * @memberof Order
     */
    'orderStatus': OrderStatus;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'orderFee'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'orderSource': string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'cid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'reference': string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'locale': string;
    /**
     * 
     * @type {Array<OrderAddress>}
     * @memberof Order
     */
    'coBuyers'?: Array<OrderAddress> | null;
    /**
     * 
     * @type {Array<OrderLine>}
     * @memberof Order
     */
    'orderLines': Array<OrderLine>;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'riskAssessmentData'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'riskAssessmentDataType'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'totalTaxAmount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Order
     */
    'totalTaxRate'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'deliveryDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'orderDate': string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'paymentDueDate': string;
    /**
     * 
     * @type {Array<PaymentMethod>}
     * @memberof Order
     */
    'paymentMethods': Array<PaymentMethod>;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'lastUpdate'?: string;
    /**
     * 
     * @type {Array<OrderAttachment>}
     * @memberof Order
     */
    'attachments': Array<OrderAttachment>;
    /**
     * 
     * @type {Array<CustomerNotification>}
     * @memberof Order
     */
    'customerNotifications': Array<CustomerNotification>;
    /**
     * 
     * @type {Array<Hook>}
     * @memberof Order
     */
    'hooks': Array<Hook>;
    /**
     * 
     * @type {OrderAddress}
     * @memberof Order
     */
    'billingAddress'?: OrderAddress;
    /**
     * 
     * @type {OrderAddress}
     * @memberof Order
     */
    'shippingAddress'?: OrderAddress;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'comments'?: string | null;
    /**
     * 
     * @type {Array<OrderLink>}
     * @memberof Order
     */
    'links'?: Array<OrderLink> | null;
    /**
     * 
     * @type {Array<OrderActivity>}
     * @memberof Order
     */
    'activities'?: Array<OrderActivity> | null;
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    'glDimension'?: string | null;
}


/**
 * 
 * @export
 * @interface OrderActivity
 */
export interface OrderActivity {
    /**
     * 
     * @type {OrderActivityType}
     * @memberof OrderActivity
     */
    'type': OrderActivityType;
    /**
     * 
     * @type {string}
     * @memberof OrderActivity
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderActivity
     */
    'completedDate'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrderActivity
     */
    'done': boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OrderActivityType = {
    VehicleRegistered: 'VEHICLE_REGISTERED',
    CollateralRegistered: 'COLLATERAL_REGISTERED',
    ContractReceived: 'CONTRACT_RECEIVED'
} as const;

export type OrderActivityType = typeof OrderActivityType[keyof typeof OrderActivityType];


/**
 * 
 * @export
 * @interface OrderAddress
 */
export interface OrderAddress {
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'legalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'companyType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'addressLine1': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'addressLine2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'zipCode': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderAddress
     */
    'co'?: string | null;
}
/**
 * 
 * @export
 * @interface OrderAttachment
 */
export interface OrderAttachment {
    /**
     * 
     * @type {string}
     * @memberof OrderAttachment
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachment
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachment
     */
    'contentType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachment
     */
    'content'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachment
     */
    'contentExtension'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderAttachment
     */
    'link'?: string | null;
}
/**
 * 
 * @export
 * @interface OrderLine
 */
export interface OrderLine {
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'lineNumber': number;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'displayName': string;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'quantityUnits': string;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'taxAmount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'taxRate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'amount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'amountIncVat': number;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'reference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'productCategory'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'productCategoryCode'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'productCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'productName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'producModel'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'environmentalImpact': number;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'gtin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'brand'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'merchantItemUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'productImageUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'registrationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'discountRate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'discountAmount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'startDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderLine
     */
    'endDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof OrderLine
     */
    'productionYear'?: number | null;
}
/**
 * 
 * @export
 * @interface OrderLink
 */
export interface OrderLink {
    /**
     * 
     * @type {string}
     * @memberof OrderLink
     */
    'url': string;
    /**
     * 
     * @type {OrderLinkType}
     * @memberof OrderLink
     */
    'type': OrderLinkType;
    /**
     * 
     * @type {string}
     * @memberof OrderLink
     */
    'displayName': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OrderLinkType = {
    Tos: 'TOS',
    Sbl: 'SBL'
} as const;

export type OrderLinkType = typeof OrderLinkType[keyof typeof OrderLinkType];


/**
 * 
 * @export
 * @interface OrderSettings
 */
export interface OrderSettings {
    /**
     * 
     * @type {string}
     * @memberof OrderSettings
     */
    'agreementId': string;
    /**
     * 
     * @type {AuthLevel}
     * @memberof OrderSettings
     */
    'requiredAuthLevel': AuthLevel;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderSettings
     */
    'allowedEmailSuffixes': Array<string>;
    /**
     * 
     * @type {MerchantTheme}
     * @memberof OrderSettings
     */
    'theme': MerchantTheme;
    /**
     * 
     * @type {Array<ProductType>}
     * @memberof OrderSettings
     */
    'products': Array<ProductType>;
    /**
     * 
     * @type {Array<AuthProvider>}
     * @memberof OrderSettings
     */
    'availableAuthenticationProviders'?: Array<AuthProvider> | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OrderStatus = {
    New: 'NEW',
    Pending: 'PENDING',
    AwaitingTaxinfo: 'AWAITING_TAXINFO',
    TaxinfoReceived: 'TAXINFO_RECEIVED',
    AwaitingSignature: 'AWAITING_SIGNATURE',
    Cancelled: 'CANCELLED',
    Deleted: 'DELETED',
    Completed: 'COMPLETED',
    PaidInFull: 'PAID_IN_FULL',
    PaidInPart: 'PAID_IN_PART',
    SignatureComplete: 'SIGNATURE_COMPLETE',
    Rejected: 'REJECTED',
    Approved: 'APPROVED',
    PendingBackoffice: 'PENDING_BACKOFFICE'
} as const;

export type OrderStatus = typeof OrderStatus[keyof typeof OrderStatus];


/**
 * 
 * @export
 * @interface PaymentMethod
 */
export interface PaymentMethod {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethod
     */
    'id': string;
    /**
     * 
     * @type {PaymentType}
     * @memberof PaymentMethod
     */
    'paymentType': PaymentType;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethod
     */
    'invoiceSentByMerchant': boolean;
    /**
     * 
     * @type {InvoiceDoumentType}
     * @memberof PaymentMethod
     */
    'invoiceDocumentType'?: InvoiceDoumentType;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'installments'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'initialPaymentAmount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'nominalInterestRate'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethod
     */
    'fixedInterestRate'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'effectiveInterestRate'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'totalPaymentAmount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'totalPaymentAmountIncTax': number;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'installmentFee'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'installmentFeeInclTax'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'initialFee'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'initialFeeIncTax'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'residualValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'monthlyPaymentAmount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PaymentMethod
     */
    'accumulatedPaymentAmount'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethod
     */
    'loanTransfer'?: boolean | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PaymentType = {
    Leasing: 'LEASING',
    Subscription: 'SUBSCRIPTION',
    Downpayments: 'DOWNPAYMENTS',
    Invoice: 'INVOICE',
    LoanTransfer: 'LOAN_TRANSFER'
} as const;

export type PaymentType = typeof PaymentType[keyof typeof PaymentType];


/**
 * 
 * @export
 * @interface Payout
 */
export interface Payout {
    /**
     * 
     * @type {string}
     * @memberof Payout
     */
    'accountNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Payout
     */
    'internalAccountNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Payout
     */
    'amount': string;
    /**
     * 
     * @type {string}
     * @memberof Payout
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Payout
     */
    'kid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Payout
     */
    'ssnOrOrgNumber'?: string | null;
}
/**
 * 
 * @export
 * @interface PayoutRequest
 */
export interface PayoutRequest {
    /**
     * 
     * @type {Array<Payout>}
     * @memberof PayoutRequest
     */
    'payouts': Array<Payout>;
}
/**
 * 
 * @export
 * @interface Pledge
 */
export interface Pledge {
    /**
     * 
     * @type {string}
     * @memberof Pledge
     */
    'ownerName': string;
    /**
     * 
     * @type {string}
     * @memberof Pledge
     */
    'ownerLegalId': string;
    /**
     * 
     * @type {string}
     * @memberof Pledge
     */
    'securedCreditorName': string;
    /**
     * 
     * @type {string}
     * @memberof Pledge
     */
    'securedCreditorLegalId': string;
    /**
     * 
     * @type {string}
     * @memberof Pledge
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof Pledge
     */
    'typeCode': string;
    /**
     * 
     * @type {string}
     * @memberof Pledge
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof Pledge
     */
    'registrationDate': string;
    /**
     * 
     * @type {string}
     * @memberof Pledge
     */
    'registrationNumber': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PowertrainType = {
    Gasoline: 'GASOLINE',
    Biodiesel: 'BIODIESEL',
    Biogasoline: 'BIOGASOLINE',
    Lpg: 'LPG',
    Cng: 'CNG',
    Methanol: 'METHANOL',
    Ethanol: 'ETHANOL',
    LpgA: 'LPG_A',
    LpgB: 'LPG_B',
    Cng20: 'CNG_20',
    Cng25: 'CNG_25',
    Diesel: 'DIESEL',
    CompressedAir: 'COMPRESSED_AIR',
    Kerosene: 'KEROSENE',
    Gas: 'GAS',
    Electric: 'ELECTRIC',
    Hydrogen: 'HYDROGEN',
    GasolineHybrid: 'GASOLINE_HYBRID',
    DieselHybrid: 'DIESEL_HYBRID',
    Other: 'OTHER'
} as const;

export type PowertrainType = typeof PowertrainType[keyof typeof PowertrainType];


/**
 * 
 * @export
 * @enum {string}
 */

export const PrepaymentEffect = {
    ReduceTermAmount: 'REDUCE_TERM_AMOUNT',
    ReduceTermCount: 'REDUCE_TERM_COUNT'
} as const;

export type PrepaymentEffect = typeof PrepaymentEffect[keyof typeof PrepaymentEffect];


/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'expectedCreditTime': number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'expectSoldAmount': number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'invoicesPerYear': number;
    /**
     * 
     * @type {ProductType}
     * @memberof Product
     */
    'productType': ProductType;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'turnoverToCorporateCustomer': number;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ProductType = {
    InvoiceSale: 'INVOICE_SALE',
    Leasing: 'LEASING',
    Loan: 'LOAN'
} as const;

export type ProductType = typeof ProductType[keyof typeof ProductType];


/**
 * 
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'ssn': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'phone': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'email': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Profile
     */
    'settings': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface ProvisionedDevice
 */
export interface ProvisionedDevice {
    /**
     * 
     * @type {string}
     * @memberof ProvisionedDevice
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ProvisionedDevice
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProvisionedDevice
     */
    'publicKey': string;
    /**
     * 
     * @type {string}
     * @memberof ProvisionedDevice
     */
    'pin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProvisionedDevice
     */
    'ownerUserId': string;
    /**
     * 
     * @type {ProvisionedDeviceStatus}
     * @memberof ProvisionedDevice
     */
    'status': ProvisionedDeviceStatus;
    /**
     * 
     * @type {string}
     * @memberof ProvisionedDevice
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProvisionedDevice
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof ProvisionedDevice
     */
    'disabledBy'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ProvisionedDeviceStatus = {
    Active: 'ACTIVE',
    Disabled: 'DISABLED'
} as const;

export type ProvisionedDeviceStatus = typeof ProvisionedDeviceStatus[keyof typeof ProvisionedDeviceStatus];


/**
 * 
 * @export
 * @interface SSTRequest
 */
export interface SSTRequest {
    /**
     * 
     * @type {string}
     * @memberof SSTRequest
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SSTRequest
     */
    'impersonateUser': string;
}
/**
 * 
 * @export
 * @interface SessionData
 */
export interface SessionData {
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'ssn'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'impersonatingUser'?: string | null;
    /**
     * 
     * @type {User}
     * @memberof SessionData
     */
    'user'?: User;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'ip': string;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'userAgent': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SessionData
     */
    'scopes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'loginDate': string;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'expiresAt': string;
    /**
     * 
     * @type {AuthLevel}
     * @memberof SessionData
     */
    'authLevel': AuthLevel;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'vendorContext'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'sb1WebSSO'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'sb1LoginRequestId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SessionData
     */
    'socialSecurityNumber'?: string | null;
}


/**
 * 
 * @export
 * @interface SingleSignOnToken
 */
export interface SingleSignOnToken {
    /**
     * 
     * @type {string}
     * @memberof SingleSignOnToken
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof SingleSignOnToken
     */
    'impersonateUser': string;
}
/**
 * 
 * @export
 * @interface StackTraceElement
 */
export interface StackTraceElement {
    /**
     * 
     * @type {string}
     * @memberof StackTraceElement
     */
    'fileName'?: string;
    /**
     * 
     * @type {number}
     * @memberof StackTraceElement
     */
    'lineNumber': number;
    /**
     * 
     * @type {string}
     * @memberof StackTraceElement
     */
    'moduleName'?: string;
    /**
     * 
     * @type {string}
     * @memberof StackTraceElement
     */
    'moduleVersion'?: string;
    /**
     * 
     * @type {string}
     * @memberof StackTraceElement
     */
    'classLoaderName'?: string;
    /**
     * 
     * @type {string}
     * @memberof StackTraceElement
     */
    'className'?: string;
    /**
     * 
     * @type {string}
     * @memberof StackTraceElement
     */
    'methodName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StackTraceElement
     */
    'nativeMethod': boolean;
}
/**
 * 
 * @export
 * @interface StartOnboardingRequest
 */
export interface StartOnboardingRequest {
    /**
     * 
     * @type {string}
     * @memberof StartOnboardingRequest
     */
    'legalId': string;
}
/**
 * 
 * @export
 * @interface StartOnboardingResponse
 */
export interface StartOnboardingResponse {
    /**
     * 
     * @type {number}
     * @memberof StartOnboardingResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof StartOnboardingResponse
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof StartOnboardingResponse
     */
    'onboardingReference': string;
}
/**
 * 
 * @export
 * @interface TaxdataSummary
 */
export interface TaxdataSummary {
    /**
     * 
     * @type {string}
     * @memberof TaxdataSummary
     */
    'personId': string;
    /**
     * 
     * @type {string}
     * @memberof TaxdataSummary
     */
    'incomeYear': string;
    /**
     * 
     * @type {string}
     * @memberof TaxdataSummary
     */
    'settlementYear'?: string;
    /**
     * 
     * @type {string}
     * @memberof TaxdataSummary
     */
    'updatedat'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TaxdataSummary
     */
    'protected': boolean;
    /**
     * 
     * @type {string}
     * @memberof TaxdataSummary
     */
    'stage'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaxdataSummary
     */
    'totalIncome': string;
    /**
     * 
     * @type {string}
     * @memberof TaxdataSummary
     */
    'totalAssets': string;
    /**
     * 
     * @type {string}
     * @memberof TaxdataSummary
     */
    'totalAssetDeductions': string;
    /**
     * 
     * @type {string}
     * @memberof TaxdataSummary
     */
    'totalAmount': string;
    /**
     * 
     * @type {string}
     * @memberof TaxdataSummary
     */
    'salaryIncome': string;
    /**
     * 
     * @type {string}
     * @memberof TaxdataSummary
     */
    'otherBusinessIncome': string;
    /**
     * 
     * @type {string}
     * @memberof TaxdataSummary
     */
    'totalPersonalBusinessIncome'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TaxdataSummary
     */
    'bankDeposits': string;
    /**
     * 
     * @type {string}
     * @memberof TaxdataSummary
     */
    'bankAccruedInterest': string;
    /**
     * 
     * @type {string}
     * @memberof TaxdataSummary
     */
    'businessDebt': string;
    /**
     * 
     * @type {string}
     * @memberof TaxdataSummary
     */
    'vehicleAssetValue': string;
    /**
     * 
     * @type {string}
     * @memberof TaxdataSummary
     */
    'equityFundValueBeforeDiscount': string;
}
/**
 * 
 * @export
 * @interface ThemeIcons
 */
export interface ThemeIcons {
    /**
     * 
     * @type {string}
     * @memberof ThemeIcons
     */
    'calculatorTopIcon': string;
    /**
     * 
     * @type {string}
     * @memberof ThemeIcons
     */
    'paymentMethodIcon': string;
    /**
     * 
     * @type {string}
     * @memberof ThemeIcons
     */
    'objectInfoIcon': string;
    /**
     * 
     * @type {string}
     * @memberof ThemeIcons
     */
    'customerInfoIcon': string;
    /**
     * 
     * @type {string}
     * @memberof ThemeIcons
     */
    'successIcon': string;
}
/**
 * 
 * @export
 * @interface Throwable
 */
export interface Throwable {
    /**
     * 
     * @type {string}
     * @memberof Throwable
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof Throwable
     */
    'localizedMessage'?: string;
    /**
     * 
     * @type {Throwable}
     * @memberof Throwable
     */
    'cause'?: Throwable;
    /**
     * 
     * @type {Array<StackTraceElement>}
     * @memberof Throwable
     */
    'stackTrace'?: Array<StackTraceElement>;
    /**
     * 
     * @type {Array<StackTraceElement>}
     * @memberof Throwable
     */
    'ourStackTrace'?: Array<StackTraceElement>;
    /**
     * 
     * @type {Array<Throwable>}
     * @memberof Throwable
     */
    'suppressed'?: Array<Throwable>;
}
/**
 * 
 * @export
 * @interface TokenLoginRequest
 */
export interface TokenLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenLoginRequest
     */
    'loginId': string;
    /**
     * 
     * @type {string}
     * @memberof TokenLoginRequest
     */
    'otp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TokenLoginRequest
     */
    'token'?: string | null;
}
/**
 * 
 * @export
 * @interface Transaction
 */
export interface Transaction {
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'sourceSystemCode': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'sourceApplicationID': string;
    /**
     * 
     * @type {number}
     * @memberof Transaction
     */
    'transactionID': number;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'transactionSource': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'sourceTransactionID': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'amount': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'accountNo': string;
    /**
     * 
     * @type {TransactionType}
     * @memberof Transaction
     */
    'transactionType': TransactionType;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'bankAccountNo': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'paymentDate': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'cid': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Transaction
     */
    'comments': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'invoiceNo': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'transactionDate': string;
    /**
     * 
     * @type {string}
     * @memberof Transaction
     */
    'vatAmount': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const TransactionType = {
    InvoicePurchase: 'INVOICE_PURCHASE',
    InvoiceFee: 'INVOICE_FEE',
    DocumentFee: 'DOCUMENT_FEE',
    Comission: 'COMISSION',
    Invoice: 'INVOICE',
    IncurredInterest: 'INCURRED_INTEREST',
    Recourse: 'RECOURSE',
    CreditNote: 'CREDIT_NOTE',
    Payment: 'PAYMENT',
    IncomingPayment: 'INCOMING_PAYMENT',
    InitialFee: 'INITIAL_FEE',
    Installment: 'INSTALLMENT',
    ExtraInstallment: 'EXTRA_INSTALLMENT',
    Other: 'OTHER'
} as const;

export type TransactionType = typeof TransactionType[keyof typeof TransactionType];


/**
 * 
 * @export
 * @interface UpdateOnboardingRequest
 */
export interface UpdateOnboardingRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateOnboardingRequest
     */
    'onboardingReference': number;
    /**
     * 
     * @type {OnboardingStatus}
     * @memberof UpdateOnboardingRequest
     */
    'onboardingStatus': OnboardingStatus;
    /**
     * 
     * @type {CreditOnboardingSource}
     * @memberof UpdateOnboardingRequest
     */
    'creditOnboardingSource': CreditOnboardingSource;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingRequest
     */
    'dealerId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingRequest
     */
    'sellerId'?: string | null;
    /**
     * 
     * @type {CustomerType}
     * @memberof UpdateOnboardingRequest
     */
    'customerType': CustomerType;
    /**
     * 
     * @type {string}
     * @memberof UpdateOnboardingRequest
     */
    'invoicingCurrency'?: string | null;
    /**
     * 
     * @type {Deliverables}
     * @memberof UpdateOnboardingRequest
     */
    'primaryDeliverables'?: Deliverables;
    /**
     * 
     * @type {InvoicingType}
     * @memberof UpdateOnboardingRequest
     */
    'invoicingType'?: InvoicingType;
    /**
     * 
     * @type {Array<CompanyInfo>}
     * @memberof UpdateOnboardingRequest
     */
    'companyInfo': Array<CompanyInfo>;
    /**
     * 
     * @type {Array<BankConnection>}
     * @memberof UpdateOnboardingRequest
     */
    'bankConnection': Array<BankConnection>;
    /**
     * 
     * @type {Array<Debtor>}
     * @memberof UpdateOnboardingRequest
     */
    'primaryDebtors': Array<Debtor>;
    /**
     * 
     * @type {Array<ContactPerson>}
     * @memberof UpdateOnboardingRequest
     */
    'contactPerson': Array<ContactPerson>;
    /**
     * 
     * @type {Array<Product>}
     * @memberof UpdateOnboardingRequest
     */
    'products': Array<Product>;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof UpdateOnboardingRequest
     */
    'attachments': Array<Attachment>;
}


/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'legalId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    'customerNumber'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'lastName': string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    'verified': boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'status': string;
    /**
     * 
     * @type {Array<UserIdentifier>}
     * @memberof User
     */
    'identifiers': Array<UserIdentifier>;
    /**
     * 
     * @type {Array<UserAddress>}
     * @memberof User
     */
    'addresses': Array<UserAddress>;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'updatedBy': string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    'phone'?: string | null;
}
/**
 * 
 * @export
 * @interface UserAddress
 */
export interface UserAddress {
    /**
     * 
     * @type {string}
     * @memberof UserAddress
     */
    'addressLine1': string;
    /**
     * 
     * @type {string}
     * @memberof UserAddress
     */
    'addressLine2': string;
    /**
     * 
     * @type {string}
     * @memberof UserAddress
     */
    'zipCode': string;
    /**
     * 
     * @type {string}
     * @memberof UserAddress
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof UserAddress
     */
    'country': string;
}
/**
 * 
 * @export
 * @interface UserIdentifier
 */
export interface UserIdentifier {
    /**
     * 
     * @type {string}
     * @memberof UserIdentifier
     */
    'identifier': string;
    /**
     * 
     * @type {UserIdentifierType}
     * @memberof UserIdentifier
     */
    'type': UserIdentifierType;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const UserIdentifierType = {
    Email: 'EMAIL',
    Ssn: 'SSN',
    Phone: 'PHONE',
    InternalId: 'INTERNAL_ID',
    SystemUser: 'SYSTEM_USER'
} as const;

export type UserIdentifierType = typeof UserIdentifierType[keyof typeof UserIdentifierType];


/**
 * 
 * @export
 * @interface Vehicle
 */
export interface Vehicle {
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'registrationNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'serialNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'registeredDate'?: string;
    /**
     * 
     * @type {VehicleRegistrationStatus}
     * @memberof Vehicle
     */
    'registrationStatus': VehicleRegistrationStatus;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'registeredWithCurrentOwnerDate'?: string;
    /**
     * 
     * @type {VehicleType}
     * @memberof Vehicle
     */
    'vehicleType': VehicleType;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'vehicleTaxCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'make'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'model'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Vehicle
     */
    'modelYear'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'color'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'co2EmissionAverage'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Vehicle
     */
    'hybrid'?: boolean | null;
    /**
     * 
     * @type {PowertrainType}
     * @memberof Vehicle
     */
    'primaryPowertrainType'?: PowertrainType;
    /**
     * 
     * @type {Array<VehicleOwner>}
     * @memberof Vehicle
     */
    'owners'?: Array<VehicleOwner> | null;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'periodicVehicleInspectionDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'periodicVehicleInspectionDueDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof Vehicle
     */
    'lastRegistryUpdate'?: string;
}


/**
 * 
 * @export
 * @interface VehicleOwner
 */
export interface VehicleOwner {
    /**
     * 
     * @type {string}
     * @memberof VehicleOwner
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleOwner
     */
    'legalId': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleOwner
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleOwner
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VehicleOwner
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleOwner
     */
    'coOwner': boolean;
    /**
     * 
     * @type {string}
     * @memberof VehicleOwner
     */
    'fromDate': string;
    /**
     * 
     * @type {string}
     * @memberof VehicleOwner
     */
    'toDate'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleRegistrationStatus = {
    Registered: 'REGISTERED',
    Unregistered: 'UNREGISTERED',
    TemporarilyUnregistered: 'TEMPORARILY_UNREGISTERED',
    Scrapped: 'SCRAPPED',
    Exported: 'EXPORTED',
    Unknown: 'UNKNOWN'
} as const;

export type VehicleRegistrationStatus = typeof VehicleRegistrationStatus[keyof typeof VehicleRegistrationStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const VehicleType = {
    Bb: 'BB',
    Bm: 'BM',
    C1: 'C1',
    C2: 'C2',
    C3: 'C3',
    C4: 'C4',
    C5: 'C5',
    L1e: 'L1e',
    L2e: 'L2e',
    L3e: 'L3e',
    L4e: 'L4e',
    L5e: 'L5e',
    L6e: 'L6e',
    L7e: 'L7e',
    M1: 'M1',
    M1G: 'M1G',
    M2: 'M2',
    M2G: 'M2G',
    M3: 'M3',
    M3G: 'M3G',
    Mcl: 'MCL',
    Mcm: 'MCM',
    Mct: 'MCT',
    Mr: 'MR',
    N1: 'N1',
    N1G: 'N1G',
    N2: 'N2',
    N2G: 'N2G',
    N3: 'N3',
    N3G: 'N3G',
    O1: 'O1',
    O2: 'O2',
    O3: 'O3',
    O4: 'O4',
    R1: 'R1',
    R2: 'R2',
    R3: 'R3',
    R4: 'R4',
    T1: 'T1',
    T2: 'T2',
    T3: 'T3',
    T4: 'T4',
    T5: 'T5',
    Tr: 'TR',
    Tt: 'TT',
    Xx: 'XX'
} as const;

export type VehicleType = typeof VehicleType[keyof typeof VehicleType];


/**
 * 
 * @export
 * @interface WebhookEventLog
 */
export interface WebhookEventLog {
    /**
     * 
     * @type {string}
     * @memberof WebhookEventLog
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WebhookEventLog
     */
    'webhookEventsId': string;
    /**
     * 
     * @type {number}
     * @memberof WebhookEventLog
     */
    'attempt': number;
    /**
     * 
     * @type {number}
     * @memberof WebhookEventLog
     */
    'responseCode'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WebhookEventLog
     */
    'responseBody': string;
    /**
     * 
     * @type {string}
     * @memberof WebhookEventLog
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const WebhookEventType = {
    OrderEvent: 'ORDER_EVENT'
} as const;

export type WebhookEventType = typeof WebhookEventType[keyof typeof WebhookEventType];


/**
 * 
 * @export
 * @interface WebhookSubscriber
 */
export interface WebhookSubscriber {
    /**
     * 
     * @type {string}
     * @memberof WebhookSubscriber
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof WebhookSubscriber
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof WebhookSubscriber
     */
    'agreementId': string;
    /**
     * 
     * @type {string}
     * @memberof WebhookSubscriber
     */
    'webhookUrl': string;
    /**
     * 
     * @type {string}
     * @memberof WebhookSubscriber
     */
    'webhookSecret': string;
    /**
     * 
     * @type {WebhookSubscriberState}
     * @memberof WebhookSubscriber
     */
    'state': WebhookSubscriberState;
    /**
     * 
     * @type {Array<WebhookEventType>}
     * @memberof WebhookSubscriber
     */
    'eventTypes': Array<WebhookEventType>;
    /**
     * 
     * @type {string}
     * @memberof WebhookSubscriber
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof WebhookSubscriber
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof WebhookSubscriber
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof WebhookSubscriber
     */
    'updatedBy': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const WebhookSubscriberState = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Deleted: 'DELETED'
} as const;

export type WebhookSubscriberState = typeof WebhookSubscriberState[keyof typeof WebhookSubscriberState];



/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get account by ID
         * @param {string} accountNumber Account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountById: async (accountNumber: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountNumber' is not null or undefined
            assertParamExists('getAccountById', 'accountNumber', accountNumber)
            const localVarPath = `/accounts/{accountNumber}`
                .replace(`{${"accountNumber"}}`, encodeURIComponent(String(accountNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get objects for selected account.
         * @param {string} accountNumber Account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObjects: async (accountNumber: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountNumber' is not null or undefined
            assertParamExists('getObjects', 'accountNumber', accountNumber)
            const localVarPath = `/accounts/{accountNumber}/objects`
                .replace(`{${"accountNumber"}}`, encodeURIComponent(String(accountNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get account by ID
         * @param {string} accountNumber Account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountById(accountNumber: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Account>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountById(accountNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.getAccountById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get objects for selected account.
         * @param {string} accountNumber Account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getObjects(accountNumber: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getObjects(accountNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountApi.getObjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * 
         * @summary Get account by ID
         * @param {string} accountNumber Account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountById(accountNumber: string, options?: AxiosRequestConfig): AxiosPromise<Account> {
            return localVarFp.getAccountById(accountNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get objects for selected account.
         * @param {string} accountNumber Account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getObjects(accountNumber: string, options?: AxiosRequestConfig): AxiosPromise<Array<object>> {
            return localVarFp.getObjects(accountNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @summary Get account by ID
     * @param {string} accountNumber Account number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getAccountById(accountNumber: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).getAccountById(accountNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get objects for selected account.
     * @param {string} accountNumber Account number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public getObjects(accountNumber: string, options?: AxiosRequestConfig) {
        return AccountApiFp(this.configuration).getObjects(accountNumber, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AccountsApi - axios parameter creator
 * @export
 */
export const AccountsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *              Generates an additional invoice for the specified account with a custom amount. This can be used to facilitate extra payments outside of the regular payment plan schedule.         
         * @summary Create extra payment invoice for account
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {ExtraPaymentInvoice} [extraPaymentInvoice] Details of the extra payment invoice to be created.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExtraPaymentInvoice: async (agreementId: string, accountId: string, extraPaymentInvoice?: ExtraPaymentInvoice, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('createExtraPaymentInvoice', 'agreementId', agreementId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('createExtraPaymentInvoice', 'accountId', accountId)
            const localVarPath = `/banking/{agreementId}/accounts/{accountId}/invoice`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(extraPaymentInvoice, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all upcoming payment installments (due dates beyond today) for the specified account.
         * @summary Get payment plan for a given account
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPaymentPlan: async (agreementId: string, accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getAccountPaymentPlan', 'agreementId', agreementId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('getAccountPaymentPlan', 'accountId', accountId)
            const localVarPath = `/banking/{agreementId}/accounts/{accountId}/paymentplan`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all invoices that have been generated for the specified account.
         * @summary List all invoices for a given account
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountInvoices: async (agreementId: string, accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('listAccountInvoices', 'agreementId', agreementId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('listAccountInvoices', 'accountId', accountId)
            const localVarPath = `/banking/{agreementId}/accounts/{accountId}/invoices`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the primary financed object linked to this account. If multiple objects exist, prefers the one with a registration number, otherwise returns the first object.
         * @summary List related objects for a given account
         * @param {string} agreementId Agreement or Merchant ID in which the account is scoped.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountObjects: async (agreementId: string, accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('listAccountObjects', 'agreementId', agreementId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('listAccountObjects', 'accountId', accountId)
            const localVarPath = `/banking/{agreementId}/accounts/{accountId}/objects`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all ledger transactions (credits and debits) associated with the specified account.
         * @summary List all transactions for a given account
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountTransactions: async (agreementId: string, accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('listAccountTransactions', 'agreementId', agreementId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('listAccountTransactions', 'accountId', accountId)
            const localVarPath = `/banking/{agreementId}/accounts/{accountId}/transactions`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves all *active* accounts for the authenticated user within the specified agreement or merchant context. Account numbers are returned as encrypted UUIDs.
         * @summary List all accounts for a given user
         * @param {string} agreementId Unique Agreement ID or Merchant ID. Use one of the whitelisted IDs for test/prod fallback.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccounts: async (agreementId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('listAccounts', 'agreementId', agreementId)
            const localVarPath = `/banking/{agreementId}/accounts`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *              Initiates termination for the specified account. Generates a final invoice due 3 days from today.             If the invoice is not settled by then, the account reverts to its previous state.         
         * @summary Request account termination
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAccountTermination: async (agreementId: string, accountId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('requestAccountTermination', 'agreementId', agreementId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('requestAccountTermination', 'accountId', accountId)
            const localVarPath = `/banking/{agreementId}/accounts/{accountId}/terminate`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *              Modify the future payment schedule for an account. You must supply **either** `termAmount` **or** `maturityDate`, not both.                          - **termAmount**: Updates the installment amount (in minor currency units, e.g. øre for NOK) for all future, non-invoiced terms.             - **maturityDate**: Sets a new final due date (format `yyyy-MM-dd`) and reflows instalments from the first non-invoiced term.         
         * @summary Update the account payment plan
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {string} [termAmount] New installment amount in **minor** currency unit (e.g. øre for NOK). Mutually exclusive with &#x60;maturityDate&#x60;.
         * @param {string} [maturityDate] New final due date in &#x60;yyyy-MM-dd&#x60; format. Mutually exclusive with &#x60;termAmount&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountPaymentPlan: async (agreementId: string, accountId: string, termAmount?: string, maturityDate?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('updateAccountPaymentPlan', 'agreementId', agreementId)
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('updateAccountPaymentPlan', 'accountId', accountId)
            const localVarPath = `/banking/{agreementId}/accounts/{accountId}/paymentplan`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (termAmount !== undefined) {
                localVarQueryParameter['termAmount'] = termAmount;
            }

            if (maturityDate !== undefined) {
                localVarQueryParameter['maturityDate'] = maturityDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountsApi - functional programming interface
 * @export
 */
export const AccountsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountsApiAxiosParamCreator(configuration)
    return {
        /**
         *              Generates an additional invoice for the specified account with a custom amount. This can be used to facilitate extra payments outside of the regular payment plan schedule.         
         * @summary Create extra payment invoice for account
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {ExtraPaymentInvoice} [extraPaymentInvoice] Details of the extra payment invoice to be created.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createExtraPaymentInvoice(agreementId: string, accountId: string, extraPaymentInvoice?: ExtraPaymentInvoice, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Invoice>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createExtraPaymentInvoice(agreementId, accountId, extraPaymentInvoice, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountsApi.createExtraPaymentInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all upcoming payment installments (due dates beyond today) for the specified account.
         * @summary Get payment plan for a given account
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccountPaymentPlan(agreementId: string, accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IncomingPayment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccountPaymentPlan(agreementId, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountsApi.getAccountPaymentPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all invoices that have been generated for the specified account.
         * @summary List all invoices for a given account
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccountInvoices(agreementId: string, accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Invoice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccountInvoices(agreementId, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountsApi.listAccountInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the primary financed object linked to this account. If multiple objects exist, prefers the one with a registration number, otherwise returns the first object.
         * @summary List related objects for a given account
         * @param {string} agreementId Agreement or Merchant ID in which the account is scoped.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccountObjects(agreementId: string, accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FinancedObject>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccountObjects(agreementId, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountsApi.listAccountObjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all ledger transactions (credits and debits) associated with the specified account.
         * @summary List all transactions for a given account
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccountTransactions(agreementId: string, accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Transaction>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccountTransactions(agreementId, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountsApi.listAccountTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves all *active* accounts for the authenticated user within the specified agreement or merchant context. Account numbers are returned as encrypted UUIDs.
         * @summary List all accounts for a given user
         * @param {string} agreementId Unique Agreement ID or Merchant ID. Use one of the whitelisted IDs for test/prod fallback.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAccounts(agreementId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Account>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAccounts(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountsApi.listAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *              Initiates termination for the specified account. Generates a final invoice due 3 days from today.             If the invoice is not settled by then, the account reverts to its previous state.         
         * @summary Request account termination
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestAccountTermination(agreementId: string, accountId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Invoice>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestAccountTermination(agreementId, accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountsApi.requestAccountTermination']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *              Modify the future payment schedule for an account. You must supply **either** `termAmount` **or** `maturityDate`, not both.                          - **termAmount**: Updates the installment amount (in minor currency units, e.g. øre for NOK) for all future, non-invoiced terms.             - **maturityDate**: Sets a new final due date (format `yyyy-MM-dd`) and reflows instalments from the first non-invoiced term.         
         * @summary Update the account payment plan
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {string} [termAmount] New installment amount in **minor** currency unit (e.g. øre for NOK). Mutually exclusive with &#x60;maturityDate&#x60;.
         * @param {string} [maturityDate] New final due date in &#x60;yyyy-MM-dd&#x60; format. Mutually exclusive with &#x60;termAmount&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAccountPaymentPlan(agreementId: string, accountId: string, termAmount?: string, maturityDate?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IncomingPayment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccountPaymentPlan(agreementId, accountId, termAmount, maturityDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AccountsApi.updateAccountPaymentPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AccountsApi - factory interface
 * @export
 */
export const AccountsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountsApiFp(configuration)
    return {
        /**
         *              Generates an additional invoice for the specified account with a custom amount. This can be used to facilitate extra payments outside of the regular payment plan schedule.         
         * @summary Create extra payment invoice for account
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {ExtraPaymentInvoice} [extraPaymentInvoice] Details of the extra payment invoice to be created.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExtraPaymentInvoice(agreementId: string, accountId: string, extraPaymentInvoice?: ExtraPaymentInvoice, options?: AxiosRequestConfig): AxiosPromise<Invoice> {
            return localVarFp.createExtraPaymentInvoice(agreementId, accountId, extraPaymentInvoice, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all upcoming payment installments (due dates beyond today) for the specified account.
         * @summary Get payment plan for a given account
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountPaymentPlan(agreementId: string, accountId: string, options?: AxiosRequestConfig): AxiosPromise<Array<IncomingPayment>> {
            return localVarFp.getAccountPaymentPlan(agreementId, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all invoices that have been generated for the specified account.
         * @summary List all invoices for a given account
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountInvoices(agreementId: string, accountId: string, options?: AxiosRequestConfig): AxiosPromise<Array<Invoice>> {
            return localVarFp.listAccountInvoices(agreementId, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the primary financed object linked to this account. If multiple objects exist, prefers the one with a registration number, otherwise returns the first object.
         * @summary List related objects for a given account
         * @param {string} agreementId Agreement or Merchant ID in which the account is scoped.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountObjects(agreementId: string, accountId: string, options?: AxiosRequestConfig): AxiosPromise<Array<FinancedObject>> {
            return localVarFp.listAccountObjects(agreementId, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all ledger transactions (credits and debits) associated with the specified account.
         * @summary List all transactions for a given account
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccountTransactions(agreementId: string, accountId: string, options?: AxiosRequestConfig): AxiosPromise<Array<Transaction>> {
            return localVarFp.listAccountTransactions(agreementId, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves all *active* accounts for the authenticated user within the specified agreement or merchant context. Account numbers are returned as encrypted UUIDs.
         * @summary List all accounts for a given user
         * @param {string} agreementId Unique Agreement ID or Merchant ID. Use one of the whitelisted IDs for test/prod fallback.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAccounts(agreementId: string, options?: AxiosRequestConfig): AxiosPromise<Array<Account>> {
            return localVarFp.listAccounts(agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         *              Initiates termination for the specified account. Generates a final invoice due 3 days from today.             If the invoice is not settled by then, the account reverts to its previous state.         
         * @summary Request account termination
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestAccountTermination(agreementId: string, accountId: string, options?: AxiosRequestConfig): AxiosPromise<Invoice> {
            return localVarFp.requestAccountTermination(agreementId, accountId, options).then((request) => request(axios, basePath));
        },
        /**
         *              Modify the future payment schedule for an account. You must supply **either** `termAmount` **or** `maturityDate`, not both.                          - **termAmount**: Updates the installment amount (in minor currency units, e.g. øre for NOK) for all future, non-invoiced terms.             - **maturityDate**: Sets a new final due date (format `yyyy-MM-dd`) and reflows instalments from the first non-invoiced term.         
         * @summary Update the account payment plan
         * @param {string} agreementId Agreement or Merchant ID.
         * @param {string} accountId Encrypted UUID of the account.
         * @param {string} [termAmount] New installment amount in **minor** currency unit (e.g. øre for NOK). Mutually exclusive with &#x60;maturityDate&#x60;.
         * @param {string} [maturityDate] New final due date in &#x60;yyyy-MM-dd&#x60; format. Mutually exclusive with &#x60;termAmount&#x60;.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccountPaymentPlan(agreementId: string, accountId: string, termAmount?: string, maturityDate?: string, options?: AxiosRequestConfig): AxiosPromise<Array<IncomingPayment>> {
            return localVarFp.updateAccountPaymentPlan(agreementId, accountId, termAmount, maturityDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountsApi - object-oriented interface
 * @export
 * @class AccountsApi
 * @extends {BaseAPI}
 */
export class AccountsApi extends BaseAPI {
    /**
     *              Generates an additional invoice for the specified account with a custom amount. This can be used to facilitate extra payments outside of the regular payment plan schedule.         
     * @summary Create extra payment invoice for account
     * @param {string} agreementId Agreement or Merchant ID.
     * @param {string} accountId Encrypted UUID of the account.
     * @param {ExtraPaymentInvoice} [extraPaymentInvoice] Details of the extra payment invoice to be created.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public createExtraPaymentInvoice(agreementId: string, accountId: string, extraPaymentInvoice?: ExtraPaymentInvoice, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).createExtraPaymentInvoice(agreementId, accountId, extraPaymentInvoice, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all upcoming payment installments (due dates beyond today) for the specified account.
     * @summary Get payment plan for a given account
     * @param {string} agreementId Agreement or Merchant ID.
     * @param {string} accountId Encrypted UUID of the account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public getAccountPaymentPlan(agreementId: string, accountId: string, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).getAccountPaymentPlan(agreementId, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all invoices that have been generated for the specified account.
     * @summary List all invoices for a given account
     * @param {string} agreementId Agreement or Merchant ID.
     * @param {string} accountId Encrypted UUID of the account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public listAccountInvoices(agreementId: string, accountId: string, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).listAccountInvoices(agreementId, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the primary financed object linked to this account. If multiple objects exist, prefers the one with a registration number, otherwise returns the first object.
     * @summary List related objects for a given account
     * @param {string} agreementId Agreement or Merchant ID in which the account is scoped.
     * @param {string} accountId Encrypted UUID of the account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public listAccountObjects(agreementId: string, accountId: string, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).listAccountObjects(agreementId, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all ledger transactions (credits and debits) associated with the specified account.
     * @summary List all transactions for a given account
     * @param {string} agreementId Agreement or Merchant ID.
     * @param {string} accountId Encrypted UUID of the account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public listAccountTransactions(agreementId: string, accountId: string, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).listAccountTransactions(agreementId, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves all *active* accounts for the authenticated user within the specified agreement or merchant context. Account numbers are returned as encrypted UUIDs.
     * @summary List all accounts for a given user
     * @param {string} agreementId Unique Agreement ID or Merchant ID. Use one of the whitelisted IDs for test/prod fallback.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public listAccounts(agreementId: string, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).listAccounts(agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *              Initiates termination for the specified account. Generates a final invoice due 3 days from today.             If the invoice is not settled by then, the account reverts to its previous state.         
     * @summary Request account termination
     * @param {string} agreementId Agreement or Merchant ID.
     * @param {string} accountId Encrypted UUID of the account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public requestAccountTermination(agreementId: string, accountId: string, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).requestAccountTermination(agreementId, accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *              Modify the future payment schedule for an account. You must supply **either** `termAmount` **or** `maturityDate`, not both.                          - **termAmount**: Updates the installment amount (in minor currency units, e.g. øre for NOK) for all future, non-invoiced terms.             - **maturityDate**: Sets a new final due date (format `yyyy-MM-dd`) and reflows instalments from the first non-invoiced term.         
     * @summary Update the account payment plan
     * @param {string} agreementId Agreement or Merchant ID.
     * @param {string} accountId Encrypted UUID of the account.
     * @param {string} [termAmount] New installment amount in **minor** currency unit (e.g. øre for NOK). Mutually exclusive with &#x60;maturityDate&#x60;.
     * @param {string} [maturityDate] New final due date in &#x60;yyyy-MM-dd&#x60; format. Mutually exclusive with &#x60;termAmount&#x60;.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountsApi
     */
    public updateAccountPaymentPlan(agreementId: string, accountId: string, termAmount?: string, maturityDate?: string, options?: AxiosRequestConfig) {
        return AccountsApiFp(this.configuration).updateAccountPaymentPlan(agreementId, accountId, termAmount, maturityDate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Associate a new dealer entity under the given agreement ID.
         * @summary Create a new dealer for an agreement
         * @param {string} agreementId Agreement under which dealer is created
         * @param {Dealer} dealer Dealer details to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAgreementAgreementIdDealerPost: async (agreementId: string, dealer: Dealer, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('adminAgreementAgreementIdDealerPost', 'agreementId', agreementId)
            // verify required parameter 'dealer' is not null or undefined
            assertParamExists('adminAgreementAgreementIdDealerPost', 'dealer', dealer)
            const localVarPath = `/admin/agreement/{agreementId}/dealer`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dealer, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Applies general configuration changes for the given agreement.
         * @summary Update general settings for agreement
         * @param {string} agreementId Agreement to update settings for
         * @param {GeneralSettings} generalSettings New general settings values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAgreementAgreementIdSettingsGeneralPut: async (agreementId: string, generalSettings: GeneralSettings, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('adminAgreementAgreementIdSettingsGeneralPut', 'agreementId', agreementId)
            // verify required parameter 'generalSettings' is not null or undefined
            assertParamExists('adminAgreementAgreementIdSettingsGeneralPut', 'generalSettings', generalSettings)
            const localVarPath = `/admin/agreement/{agreementId}/settings/general`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(generalSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches UI configuration values for the order page of an agreement.
         * @summary Get order page settings
         * @param {string} agreementId Agreement identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAgreementAgreementIdSettingsOrderGet: async (agreementId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('adminAgreementAgreementIdSettingsOrderGet', 'agreementId', agreementId)
            const localVarPath = `/admin/agreement/{agreementId}/settings/order`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates UI configuration for the order page of an agreement.
         * @summary Update order page settings
         * @param {string} agreementId Agreement identifier
         * @param {OrderSettings} orderSettings New order page settings values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAgreementAgreementIdSettingsOrderPut: async (agreementId: string, orderSettings: OrderSettings, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('adminAgreementAgreementIdSettingsOrderPut', 'agreementId', agreementId)
            // verify required parameter 'orderSettings' is not null or undefined
            assertParamExists('adminAgreementAgreementIdSettingsOrderPut', 'orderSettings', orderSettings)
            const localVarPath = `/admin/agreement/{agreementId}/settings/order`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderSettings, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a custom theme for merchant UI under the specified agreement.
         * @summary Add a new merchant theme
         * @param {string} agreementId Agreement ID to add theme to
         * @param {MerchantTheme} merchantTheme Theme customization details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAgreementAgreementIdThemePost: async (agreementId: string, merchantTheme: MerchantTheme, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('adminAgreementAgreementIdThemePost', 'agreementId', agreementId)
            // verify required parameter 'merchantTheme' is not null or undefined
            assertParamExists('adminAgreementAgreementIdThemePost', 'merchantTheme', merchantTheme)
            const localVarPath = `/admin/agreement/{agreementId}/theme`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(merchantTheme, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modifies properties of an existing merchant theme under the specified agreement.
         * @summary Update existing merchant theme
         * @param {string} agreementId Agreement containing the theme
         * @param {string} themeId Unique theme identifier
         * @param {MerchantTheme} merchantTheme Updated theme properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAgreementAgreementIdThemeThemeIdPut: async (agreementId: string, themeId: string, merchantTheme: MerchantTheme, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('adminAgreementAgreementIdThemeThemeIdPut', 'agreementId', agreementId)
            // verify required parameter 'themeId' is not null or undefined
            assertParamExists('adminAgreementAgreementIdThemeThemeIdPut', 'themeId', themeId)
            // verify required parameter 'merchantTheme' is not null or undefined
            assertParamExists('adminAgreementAgreementIdThemeThemeIdPut', 'merchantTheme', merchantTheme)
            const localVarPath = `/admin/agreement/{agreementId}/theme/{themeId}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"themeId"}}`, encodeURIComponent(String(themeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(merchantTheme, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Checks if the provided account number belongs to an individual or organization by SSN or organization number.
         * @summary Verify bank account ownership
         * @param {string} accountNumber The bank account number to verify
         * @param {string} [organizationNumber] Organization number, mutually exclusive with ssn
         * @param {string} [ssn] Social security number, mutually exclusive with organizationNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBankaccountVerificationGet: async (accountNumber: string, organizationNumber?: string, ssn?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountNumber' is not null or undefined
            assertParamExists('adminBankaccountVerificationGet', 'accountNumber', accountNumber)
            const localVarPath = `/admin/bankaccount/verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (accountNumber !== undefined) {
                localVarQueryParameter['accountNumber'] = accountNumber;
            }

            if (organizationNumber !== undefined) {
                localVarQueryParameter['organizationNumber'] = organizationNumber;
            }

            if (ssn !== undefined) {
                localVarQueryParameter['ssn'] = ssn;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the generated file for a completed batch job by job ID.
         * @summary Download batch job result
         * @param {string} jobId Identifier of the batch job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLetterJobIdGet: async (jobId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobId' is not null or undefined
            assertParamExists('adminLetterJobIdGet', 'jobId', jobId)
            const localVarPath = `/admin/letter/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Processes a CSV batch file of interest letters, scheduling generation asynchronously.
         * @summary Upload batch interest letters
         * @param {string} interestDate Date for interest letters in ISO format
         * @param {object} body Multipart file with letters list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLetterPost: async (interestDate: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interestDate' is not null or undefined
            assertParamExists('adminLetterPost', 'interestDate', interestDate)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('adminLetterPost', 'body', body)
            const localVarPath = `/admin/letter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (interestDate !== undefined) {
                localVarQueryParameter['interestDate'] = interestDate;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authenticate an admin user and create a session with elevated SYSTEM_ADMIN scope.
         * @summary Admin user login
         * @param {LoginRequest} loginRequest Login credentials (username/password)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLoginPost: async (loginRequest: LoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('adminLoginPost', 'loginRequest', loginRequest)
            const localVarPath = `/admin/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves PDF message metadata for a customer identified by SSN.
         * @summary List user messages
         * @param {string} ssn Customer social security number to fetch messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMessagesGet: async (ssn: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ssn' is not null or undefined
            assertParamExists('adminMessagesGet', 'ssn', ssn)
            const localVarPath = `/admin/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ssn !== undefined) {
                localVarQueryParameter['ssn'] = ssn;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches the PDF file content for a specific message.
         * @summary Download a user message
         * @param {string} messageId Identifier of the message to download
         * @param {string} ssn Customer social security number used to authenticate access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMessagesMessageIdGet: async (messageId: string, ssn: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('adminMessagesMessageIdGet', 'messageId', messageId)
            // verify required parameter 'ssn' is not null or undefined
            assertParamExists('adminMessagesMessageIdGet', 'ssn', ssn)
            const localVarPath = `/admin/messages/{messageId}`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ssn !== undefined) {
                localVarQueryParameter['ssn'] = ssn;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the content of a specific document associated with an order.
         * @summary Download specific order document
         * @param {number} orderId Internal ID of the order
         * @param {string} documentId Unique ID of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderOrderIdDocumentsDocumentIdGet: async (orderId: number, documentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrderOrderIdDocumentsDocumentIdGet', 'orderId', orderId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('adminOrderOrderIdDocumentsDocumentIdGet', 'documentId', documentId)
            const localVarPath = `/admin/order/{orderId}/documents/{documentId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates an AI-driven summary of a document\'s content.
         * @summary Summarize document
         * @param {number} orderId Internal ID of the order
         * @param {string} documentId Unique ID of the document to summarize
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderOrderIdDocumentsDocumentIdSummaryGet: async (orderId: number, documentId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrderOrderIdDocumentsDocumentIdSummaryGet', 'orderId', orderId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('adminOrderOrderIdDocumentsDocumentIdSummaryGet', 'documentId', documentId)
            const localVarPath = `/admin/order/{orderId}/documents/{documentId}/summary`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns metadata for all documents associated with an order.
         * @summary List documents for order
         * @param {number} orderId Internal ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderOrderIdDocumentsGet: async (orderId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrderOrderIdDocumentsGet', 'orderId', orderId)
            const localVarPath = `/admin/order/{orderId}/documents`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve detailed information for a specific order by its internal identifier.
         * @summary Get an order by ID
         * @param {number} orderId Internal ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderOrderIdGet: async (orderId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrderOrderIdGet', 'orderId', orderId)
            const localVarPath = `/admin/order/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Processes payout requests for a given order by authorized admin.
         * @summary Execute payouts for an order
         * @param {number} orderId Internal ID of order to payout
         * @param {PayoutRequest} payoutRequest List of payouts to execute
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderOrderIdPayoutPost: async (orderId: number, payoutRequest: PayoutRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrderOrderIdPayoutPost', 'orderId', orderId)
            // verify required parameter 'payoutRequest' is not null or undefined
            assertParamExists('adminOrderOrderIdPayoutPost', 'payoutRequest', payoutRequest)
            const localVarPath = `/admin/order/{orderId}/payout`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payoutRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves public pledge data for a given company registration number.
         * @summary Get pledges for a registration number
         * @param {string} registrationNumber Company registration number to lookup pledges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPledgesGet: async (registrationNumber: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registrationNumber' is not null or undefined
            assertParamExists('adminPledgesGet', 'registrationNumber', registrationNumber)
            const localVarPath = `/admin/pledges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (registrationNumber !== undefined) {
                localVarQueryParameter['registrationNumber'] = registrationNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Generates a token to allow one user to impersonate another.
         * @summary Create single sign-on token
         * @param {SSTRequest} sSTRequest User context for token generation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSstPost: async (sSTRequest: SSTRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sSTRequest' is not null or undefined
            assertParamExists('adminSstPost', 'sSTRequest', sSTRequest)
            const localVarPath = `/admin/sst`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sSTRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves orders optionally filtered by update date range, status, and supports pagination.
         * @summary List all orders with filters
         * @param {string} [fromUpdateDate] ISO8601 date filter start
         * @param {string} [toUpdateDate] ISO8601 date filter end
         * @param {string} [statuses] Comma-separated order statuses
         * @param {string} [dealerGroup] Filter by dealer group name
         * @param {number} [maxCount] Maximum number of results to return
         * @param {string} [nextPageToken] Pagination token for next page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrders: async (fromUpdateDate?: string, toUpdateDate?: string, statuses?: string, dealerGroup?: string, maxCount?: number, nextPageToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromUpdateDate !== undefined) {
                localVarQueryParameter['fromUpdateDate'] = fromUpdateDate;
            }

            if (toUpdateDate !== undefined) {
                localVarQueryParameter['toUpdateDate'] = toUpdateDate;
            }

            if (statuses !== undefined) {
                localVarQueryParameter['statuses'] = statuses;
            }

            if (dealerGroup !== undefined) {
                localVarQueryParameter['dealerGroup'] = dealerGroup;
            }

            if (maxCount !== undefined) {
                localVarQueryParameter['maxCount'] = maxCount;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * Associate a new dealer entity under the given agreement ID.
         * @summary Create a new dealer for an agreement
         * @param {string} agreementId Agreement under which dealer is created
         * @param {Dealer} dealer Dealer details to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAgreementAgreementIdDealerPost(agreementId: string, dealer: Dealer, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Dealer>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAgreementAgreementIdDealerPost(agreementId, dealer, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminAgreementAgreementIdDealerPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Applies general configuration changes for the given agreement.
         * @summary Update general settings for agreement
         * @param {string} agreementId Agreement to update settings for
         * @param {GeneralSettings} generalSettings New general settings values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAgreementAgreementIdSettingsGeneralPut(agreementId: string, generalSettings: GeneralSettings, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAgreementAgreementIdSettingsGeneralPut(agreementId, generalSettings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminAgreementAgreementIdSettingsGeneralPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches UI configuration values for the order page of an agreement.
         * @summary Get order page settings
         * @param {string} agreementId Agreement identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAgreementAgreementIdSettingsOrderGet(agreementId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAgreementAgreementIdSettingsOrderGet(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminAgreementAgreementIdSettingsOrderGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates UI configuration for the order page of an agreement.
         * @summary Update order page settings
         * @param {string} agreementId Agreement identifier
         * @param {OrderSettings} orderSettings New order page settings values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAgreementAgreementIdSettingsOrderPut(agreementId: string, orderSettings: OrderSettings, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAgreementAgreementIdSettingsOrderPut(agreementId, orderSettings, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminAgreementAgreementIdSettingsOrderPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a custom theme for merchant UI under the specified agreement.
         * @summary Add a new merchant theme
         * @param {string} agreementId Agreement ID to add theme to
         * @param {MerchantTheme} merchantTheme Theme customization details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAgreementAgreementIdThemePost(agreementId: string, merchantTheme: MerchantTheme, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantTheme>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAgreementAgreementIdThemePost(agreementId, merchantTheme, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminAgreementAgreementIdThemePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modifies properties of an existing merchant theme under the specified agreement.
         * @summary Update existing merchant theme
         * @param {string} agreementId Agreement containing the theme
         * @param {string} themeId Unique theme identifier
         * @param {MerchantTheme} merchantTheme Updated theme properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminAgreementAgreementIdThemeThemeIdPut(agreementId: string, themeId: string, merchantTheme: MerchantTheme, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminAgreementAgreementIdThemeThemeIdPut(agreementId, themeId, merchantTheme, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminAgreementAgreementIdThemeThemeIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Checks if the provided account number belongs to an individual or organization by SSN or organization number.
         * @summary Verify bank account ownership
         * @param {string} accountNumber The bank account number to verify
         * @param {string} [organizationNumber] Organization number, mutually exclusive with ssn
         * @param {string} [ssn] Social security number, mutually exclusive with organizationNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminBankaccountVerificationGet(accountNumber: string, organizationNumber?: string, ssn?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminBankaccountVerificationGet(accountNumber, organizationNumber, ssn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminBankaccountVerificationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the generated file for a completed batch job by job ID.
         * @summary Download batch job result
         * @param {string} jobId Identifier of the batch job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLetterJobIdGet(jobId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLetterJobIdGet(jobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminLetterJobIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Processes a CSV batch file of interest letters, scheduling generation asynchronously.
         * @summary Upload batch interest letters
         * @param {string} interestDate Date for interest letters in ISO format
         * @param {object} body Multipart file with letters list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLetterPost(interestDate: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLetterPost(interestDate, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminLetterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authenticate an admin user and create a session with elevated SYSTEM_ADMIN scope.
         * @summary Admin user login
         * @param {LoginRequest} loginRequest Login credentials (username/password)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminLoginPost(loginRequest: LoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminLoginPost(loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves PDF message metadata for a customer identified by SSN.
         * @summary List user messages
         * @param {string} ssn Customer social security number to fetch messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminMessagesGet(ssn: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Message>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminMessagesGet(ssn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminMessagesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches the PDF file content for a specific message.
         * @summary Download a user message
         * @param {string} messageId Identifier of the message to download
         * @param {string} ssn Customer social security number used to authenticate access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminMessagesMessageIdGet(messageId: string, ssn: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminMessagesMessageIdGet(messageId, ssn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminMessagesMessageIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the content of a specific document associated with an order.
         * @summary Download specific order document
         * @param {number} orderId Internal ID of the order
         * @param {string} documentId Unique ID of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrderOrderIdDocumentsDocumentIdGet(orderId: number, documentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrderOrderIdDocumentsDocumentIdGet(orderId, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminOrderOrderIdDocumentsDocumentIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates an AI-driven summary of a document\'s content.
         * @summary Summarize document
         * @param {number} orderId Internal ID of the order
         * @param {string} documentId Unique ID of the document to summarize
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrderOrderIdDocumentsDocumentIdSummaryGet(orderId: number, documentId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrderOrderIdDocumentsDocumentIdSummaryGet(orderId, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminOrderOrderIdDocumentsDocumentIdSummaryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns metadata for all documents associated with an order.
         * @summary List documents for order
         * @param {number} orderId Internal ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrderOrderIdDocumentsGet(orderId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Document>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrderOrderIdDocumentsGet(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminOrderOrderIdDocumentsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve detailed information for a specific order by its internal identifier.
         * @summary Get an order by ID
         * @param {number} orderId Internal ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrderOrderIdGet(orderId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrderOrderIdGet(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminOrderOrderIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Processes payout requests for a given order by authorized admin.
         * @summary Execute payouts for an order
         * @param {number} orderId Internal ID of order to payout
         * @param {PayoutRequest} payoutRequest List of payouts to execute
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminOrderOrderIdPayoutPost(orderId: number, payoutRequest: PayoutRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminOrderOrderIdPayoutPost(orderId, payoutRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminOrderOrderIdPayoutPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves public pledge data for a given company registration number.
         * @summary Get pledges for a registration number
         * @param {string} registrationNumber Company registration number to lookup pledges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPledgesGet(registrationNumber: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Pledge>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPledgesGet(registrationNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminPledgesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Generates a token to allow one user to impersonate another.
         * @summary Create single sign-on token
         * @param {SSTRequest} sSTRequest User context for token generation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminSstPost(sSTRequest: SSTRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SingleSignOnToken>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminSstPost(sSTRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminSstPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves orders optionally filtered by update date range, status, and supports pagination.
         * @summary List all orders with filters
         * @param {string} [fromUpdateDate] ISO8601 date filter start
         * @param {string} [toUpdateDate] ISO8601 date filter end
         * @param {string} [statuses] Comma-separated order statuses
         * @param {string} [dealerGroup] Filter by dealer group name
         * @param {number} [maxCount] Maximum number of results to return
         * @param {string} [nextPageToken] Pagination token for next page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrders(fromUpdateDate?: string, toUpdateDate?: string, statuses?: string, dealerGroup?: string, maxCount?: number, nextPageToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Order>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrders(fromUpdateDate, toUpdateDate, statuses, dealerGroup, maxCount, nextPageToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.listOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * Associate a new dealer entity under the given agreement ID.
         * @summary Create a new dealer for an agreement
         * @param {string} agreementId Agreement under which dealer is created
         * @param {Dealer} dealer Dealer details to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAgreementAgreementIdDealerPost(agreementId: string, dealer: Dealer, options?: AxiosRequestConfig): AxiosPromise<Dealer> {
            return localVarFp.adminAgreementAgreementIdDealerPost(agreementId, dealer, options).then((request) => request(axios, basePath));
        },
        /**
         * Applies general configuration changes for the given agreement.
         * @summary Update general settings for agreement
         * @param {string} agreementId Agreement to update settings for
         * @param {GeneralSettings} generalSettings New general settings values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAgreementAgreementIdSettingsGeneralPut(agreementId: string, generalSettings: GeneralSettings, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminAgreementAgreementIdSettingsGeneralPut(agreementId, generalSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches UI configuration values for the order page of an agreement.
         * @summary Get order page settings
         * @param {string} agreementId Agreement identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAgreementAgreementIdSettingsOrderGet(agreementId: string, options?: AxiosRequestConfig): AxiosPromise<OrderSettings> {
            return localVarFp.adminAgreementAgreementIdSettingsOrderGet(agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates UI configuration for the order page of an agreement.
         * @summary Update order page settings
         * @param {string} agreementId Agreement identifier
         * @param {OrderSettings} orderSettings New order page settings values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAgreementAgreementIdSettingsOrderPut(agreementId: string, orderSettings: OrderSettings, options?: AxiosRequestConfig): AxiosPromise<OrderSettings> {
            return localVarFp.adminAgreementAgreementIdSettingsOrderPut(agreementId, orderSettings, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a custom theme for merchant UI under the specified agreement.
         * @summary Add a new merchant theme
         * @param {string} agreementId Agreement ID to add theme to
         * @param {MerchantTheme} merchantTheme Theme customization details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAgreementAgreementIdThemePost(agreementId: string, merchantTheme: MerchantTheme, options?: AxiosRequestConfig): AxiosPromise<MerchantTheme> {
            return localVarFp.adminAgreementAgreementIdThemePost(agreementId, merchantTheme, options).then((request) => request(axios, basePath));
        },
        /**
         * Modifies properties of an existing merchant theme under the specified agreement.
         * @summary Update existing merchant theme
         * @param {string} agreementId Agreement containing the theme
         * @param {string} themeId Unique theme identifier
         * @param {MerchantTheme} merchantTheme Updated theme properties
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAgreementAgreementIdThemeThemeIdPut(agreementId: string, themeId: string, merchantTheme: MerchantTheme, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminAgreementAgreementIdThemeThemeIdPut(agreementId, themeId, merchantTheme, options).then((request) => request(axios, basePath));
        },
        /**
         * Checks if the provided account number belongs to an individual or organization by SSN or organization number.
         * @summary Verify bank account ownership
         * @param {string} accountNumber The bank account number to verify
         * @param {string} [organizationNumber] Organization number, mutually exclusive with ssn
         * @param {string} [ssn] Social security number, mutually exclusive with organizationNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminBankaccountVerificationGet(accountNumber: string, organizationNumber?: string, ssn?: string, options?: AxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.adminBankaccountVerificationGet(accountNumber, organizationNumber, ssn, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the generated file for a completed batch job by job ID.
         * @summary Download batch job result
         * @param {string} jobId Identifier of the batch job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLetterJobIdGet(jobId: string, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.adminLetterJobIdGet(jobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Processes a CSV batch file of interest letters, scheduling generation asynchronously.
         * @summary Upload batch interest letters
         * @param {string} interestDate Date for interest letters in ISO format
         * @param {object} body Multipart file with letters list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLetterPost(interestDate: string, body: object, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminLetterPost(interestDate, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Authenticate an admin user and create a session with elevated SYSTEM_ADMIN scope.
         * @summary Admin user login
         * @param {LoginRequest} loginRequest Login credentials (username/password)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLoginPost(loginRequest: LoginRequest, options?: AxiosRequestConfig): AxiosPromise<SessionData> {
            return localVarFp.adminLoginPost(loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves PDF message metadata for a customer identified by SSN.
         * @summary List user messages
         * @param {string} ssn Customer social security number to fetch messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMessagesGet(ssn: string, options?: AxiosRequestConfig): AxiosPromise<Array<Message>> {
            return localVarFp.adminMessagesGet(ssn, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches the PDF file content for a specific message.
         * @summary Download a user message
         * @param {string} messageId Identifier of the message to download
         * @param {string} ssn Customer social security number used to authenticate access
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminMessagesMessageIdGet(messageId: string, ssn: string, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.adminMessagesMessageIdGet(messageId, ssn, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the content of a specific document associated with an order.
         * @summary Download specific order document
         * @param {number} orderId Internal ID of the order
         * @param {string} documentId Unique ID of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderOrderIdDocumentsDocumentIdGet(orderId: number, documentId: string, options?: AxiosRequestConfig): AxiosPromise<Document> {
            return localVarFp.adminOrderOrderIdDocumentsDocumentIdGet(orderId, documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates an AI-driven summary of a document\'s content.
         * @summary Summarize document
         * @param {number} orderId Internal ID of the order
         * @param {string} documentId Unique ID of the document to summarize
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderOrderIdDocumentsDocumentIdSummaryGet(orderId: number, documentId: string, options?: AxiosRequestConfig): AxiosPromise<DocumentSummary> {
            return localVarFp.adminOrderOrderIdDocumentsDocumentIdSummaryGet(orderId, documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns metadata for all documents associated with an order.
         * @summary List documents for order
         * @param {number} orderId Internal ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderOrderIdDocumentsGet(orderId: number, options?: AxiosRequestConfig): AxiosPromise<Array<Document>> {
            return localVarFp.adminOrderOrderIdDocumentsGet(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve detailed information for a specific order by its internal identifier.
         * @summary Get an order by ID
         * @param {number} orderId Internal ID of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderOrderIdGet(orderId: number, options?: AxiosRequestConfig): AxiosPromise<Order> {
            return localVarFp.adminOrderOrderIdGet(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Processes payout requests for a given order by authorized admin.
         * @summary Execute payouts for an order
         * @param {number} orderId Internal ID of order to payout
         * @param {PayoutRequest} payoutRequest List of payouts to execute
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderOrderIdPayoutPost(orderId: number, payoutRequest: PayoutRequest, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.adminOrderOrderIdPayoutPost(orderId, payoutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves public pledge data for a given company registration number.
         * @summary Get pledges for a registration number
         * @param {string} registrationNumber Company registration number to lookup pledges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPledgesGet(registrationNumber: string, options?: AxiosRequestConfig): AxiosPromise<Array<Pledge>> {
            return localVarFp.adminPledgesGet(registrationNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Generates a token to allow one user to impersonate another.
         * @summary Create single sign-on token
         * @param {SSTRequest} sSTRequest User context for token generation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSstPost(sSTRequest: SSTRequest, options?: AxiosRequestConfig): AxiosPromise<SingleSignOnToken> {
            return localVarFp.adminSstPost(sSTRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves orders optionally filtered by update date range, status, and supports pagination.
         * @summary List all orders with filters
         * @param {string} [fromUpdateDate] ISO8601 date filter start
         * @param {string} [toUpdateDate] ISO8601 date filter end
         * @param {string} [statuses] Comma-separated order statuses
         * @param {string} [dealerGroup] Filter by dealer group name
         * @param {number} [maxCount] Maximum number of results to return
         * @param {string} [nextPageToken] Pagination token for next page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrders(fromUpdateDate?: string, toUpdateDate?: string, statuses?: string, dealerGroup?: string, maxCount?: number, nextPageToken?: string, options?: AxiosRequestConfig): AxiosPromise<Array<Order>> {
            return localVarFp.listOrders(fromUpdateDate, toUpdateDate, statuses, dealerGroup, maxCount, nextPageToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI {
    /**
     * Associate a new dealer entity under the given agreement ID.
     * @summary Create a new dealer for an agreement
     * @param {string} agreementId Agreement under which dealer is created
     * @param {Dealer} dealer Dealer details to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminAgreementAgreementIdDealerPost(agreementId: string, dealer: Dealer, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminAgreementAgreementIdDealerPost(agreementId, dealer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Applies general configuration changes for the given agreement.
     * @summary Update general settings for agreement
     * @param {string} agreementId Agreement to update settings for
     * @param {GeneralSettings} generalSettings New general settings values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminAgreementAgreementIdSettingsGeneralPut(agreementId: string, generalSettings: GeneralSettings, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminAgreementAgreementIdSettingsGeneralPut(agreementId, generalSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches UI configuration values for the order page of an agreement.
     * @summary Get order page settings
     * @param {string} agreementId Agreement identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminAgreementAgreementIdSettingsOrderGet(agreementId: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminAgreementAgreementIdSettingsOrderGet(agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates UI configuration for the order page of an agreement.
     * @summary Update order page settings
     * @param {string} agreementId Agreement identifier
     * @param {OrderSettings} orderSettings New order page settings values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminAgreementAgreementIdSettingsOrderPut(agreementId: string, orderSettings: OrderSettings, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminAgreementAgreementIdSettingsOrderPut(agreementId, orderSettings, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a custom theme for merchant UI under the specified agreement.
     * @summary Add a new merchant theme
     * @param {string} agreementId Agreement ID to add theme to
     * @param {MerchantTheme} merchantTheme Theme customization details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminAgreementAgreementIdThemePost(agreementId: string, merchantTheme: MerchantTheme, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminAgreementAgreementIdThemePost(agreementId, merchantTheme, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Modifies properties of an existing merchant theme under the specified agreement.
     * @summary Update existing merchant theme
     * @param {string} agreementId Agreement containing the theme
     * @param {string} themeId Unique theme identifier
     * @param {MerchantTheme} merchantTheme Updated theme properties
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminAgreementAgreementIdThemeThemeIdPut(agreementId: string, themeId: string, merchantTheme: MerchantTheme, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminAgreementAgreementIdThemeThemeIdPut(agreementId, themeId, merchantTheme, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Checks if the provided account number belongs to an individual or organization by SSN or organization number.
     * @summary Verify bank account ownership
     * @param {string} accountNumber The bank account number to verify
     * @param {string} [organizationNumber] Organization number, mutually exclusive with ssn
     * @param {string} [ssn] Social security number, mutually exclusive with organizationNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminBankaccountVerificationGet(accountNumber: string, organizationNumber?: string, ssn?: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminBankaccountVerificationGet(accountNumber, organizationNumber, ssn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the generated file for a completed batch job by job ID.
     * @summary Download batch job result
     * @param {string} jobId Identifier of the batch job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminLetterJobIdGet(jobId: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminLetterJobIdGet(jobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Processes a CSV batch file of interest letters, scheduling generation asynchronously.
     * @summary Upload batch interest letters
     * @param {string} interestDate Date for interest letters in ISO format
     * @param {object} body Multipart file with letters list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminLetterPost(interestDate: string, body: object, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminLetterPost(interestDate, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Authenticate an admin user and create a session with elevated SYSTEM_ADMIN scope.
     * @summary Admin user login
     * @param {LoginRequest} loginRequest Login credentials (username/password)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminLoginPost(loginRequest: LoginRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminLoginPost(loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves PDF message metadata for a customer identified by SSN.
     * @summary List user messages
     * @param {string} ssn Customer social security number to fetch messages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminMessagesGet(ssn: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminMessagesGet(ssn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches the PDF file content for a specific message.
     * @summary Download a user message
     * @param {string} messageId Identifier of the message to download
     * @param {string} ssn Customer social security number used to authenticate access
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminMessagesMessageIdGet(messageId: string, ssn: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminMessagesMessageIdGet(messageId, ssn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the content of a specific document associated with an order.
     * @summary Download specific order document
     * @param {number} orderId Internal ID of the order
     * @param {string} documentId Unique ID of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminOrderOrderIdDocumentsDocumentIdGet(orderId: number, documentId: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminOrderOrderIdDocumentsDocumentIdGet(orderId, documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates an AI-driven summary of a document\'s content.
     * @summary Summarize document
     * @param {number} orderId Internal ID of the order
     * @param {string} documentId Unique ID of the document to summarize
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminOrderOrderIdDocumentsDocumentIdSummaryGet(orderId: number, documentId: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminOrderOrderIdDocumentsDocumentIdSummaryGet(orderId, documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns metadata for all documents associated with an order.
     * @summary List documents for order
     * @param {number} orderId Internal ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminOrderOrderIdDocumentsGet(orderId: number, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminOrderOrderIdDocumentsGet(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve detailed information for a specific order by its internal identifier.
     * @summary Get an order by ID
     * @param {number} orderId Internal ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminOrderOrderIdGet(orderId: number, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminOrderOrderIdGet(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Processes payout requests for a given order by authorized admin.
     * @summary Execute payouts for an order
     * @param {number} orderId Internal ID of order to payout
     * @param {PayoutRequest} payoutRequest List of payouts to execute
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminOrderOrderIdPayoutPost(orderId: number, payoutRequest: PayoutRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminOrderOrderIdPayoutPost(orderId, payoutRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves public pledge data for a given company registration number.
     * @summary Get pledges for a registration number
     * @param {string} registrationNumber Company registration number to lookup pledges
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminPledgesGet(registrationNumber: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminPledgesGet(registrationNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Generates a token to allow one user to impersonate another.
     * @summary Create single sign-on token
     * @param {SSTRequest} sSTRequest User context for token generation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public adminSstPost(sSTRequest: SSTRequest, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminSstPost(sSTRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves orders optionally filtered by update date range, status, and supports pagination.
     * @summary List all orders with filters
     * @param {string} [fromUpdateDate] ISO8601 date filter start
     * @param {string} [toUpdateDate] ISO8601 date filter end
     * @param {string} [statuses] Comma-separated order statuses
     * @param {string} [dealerGroup] Filter by dealer group name
     * @param {number} [maxCount] Maximum number of results to return
     * @param {string} [nextPageToken] Pagination token for next page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public listOrders(fromUpdateDate?: string, toUpdateDate?: string, statuses?: string, dealerGroup?: string, maxCount?: number, nextPageToken?: string, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).listOrders(fromUpdateDate, toUpdateDate, statuses, dealerGroup, maxCount, nextPageToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AgreementApi - axios parameter creator
 * @export
 */
export const AgreementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *              Adds plugin functionality (e.g., SFTP, ERP connectors) to the specified agreement.             The request body must include add-on name and configuration settings.         
         * @summary Install an add-on into an agreement
         * @param {string} agreementId The ID of the agreement to attach the add-on to.
         * @param {AddOnRequest} [addOnRequest] Payload specifying which add-on to install and its configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddOn: async (agreementId: string, addOnRequest?: AddOnRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('createAddOn', 'agreementId', agreementId)
            const localVarPath = `/agreements/{agreementId}/settings/addon`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addOnRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetches detailed information about the specified agreement, including status and linked resources.
         * @summary Get a single agreement by its ID
         * @param {string} agreementId The UUID of the agreement to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreementById: async (agreementId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getAgreementById', 'agreementId', agreementId)
            const localVarPath = `/agreements/{agreementId}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *              Provides aggregated metrics (e.g., total balance, number of active agreements)             across all agreements accessible to the user.         
         * @summary Get aggregated summary across all agreements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreementSummary: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agreements/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all delivery attempts and responses for the specified webhook subscription.
         * @summary Fetch event logs for a webhook
         * @param {string} agreementId The ID of the agreement.
         * @param {string} webhookSettingsId The ID of the webhook subscription.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookLogs: async (agreementId: string, webhookSettingsId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getWebhookLogs', 'agreementId', agreementId)
            // verify required parameter 'webhookSettingsId' is not null or undefined
            assertParamExists('getWebhookLogs', 'webhookSettingsId', webhookSettingsId)
            const localVarPath = `/agreements/{agreementId}/settings/webhook/{webhookSettingsId}/logs`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"webhookSettingsId"}}`, encodeURIComponent(String(webhookSettingsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves every configured webhook subscriber for the given agreement.
         * @summary List all webhook subscriptions
         * @param {string} agreementId The ID of the agreement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookSettings: async (agreementId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getWebhookSettings', 'agreementId', agreementId)
            const localVarPath = `/agreements/{agreementId}/settings/webhook`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *              Grants specified permissions to a user on the given agreement.             Existing permissions for that user will be replaced.         
         * @summary Grant or update user access to an agreement
         * @param {string} agreementId The ID of the agreement to modify ACL for.
         * @param {AgreementMember} [agreementMember] The AgreementMember payload containing user ID, scopes, and contact info.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantAccessToAgreement: async (agreementId: string, agreementMember?: AgreementMember, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('grantAccessToAgreement', 'agreementId', agreementId)
            const localVarPath = `/agreements/{agreementId}/settings/acl`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agreementMember, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *              Returns a list of bank‐connection agreements for the requesting user.             Each agreement includes metadata such as creation date, status, and associated customer.         
         * @summary List all agreements visible to the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgreements: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/agreements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgreementApi - functional programming interface
 * @export
 */
export const AgreementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgreementApiAxiosParamCreator(configuration)
    return {
        /**
         *              Adds plugin functionality (e.g., SFTP, ERP connectors) to the specified agreement.             The request body must include add-on name and configuration settings.         
         * @summary Install an add-on into an agreement
         * @param {string} agreementId The ID of the agreement to attach the add-on to.
         * @param {AddOnRequest} [addOnRequest] Payload specifying which add-on to install and its configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAddOn(agreementId: string, addOnRequest?: AddOnRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Agreement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAddOn(agreementId, addOnRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.createAddOn']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetches detailed information about the specified agreement, including status and linked resources.
         * @summary Get a single agreement by its ID
         * @param {string} agreementId The UUID of the agreement to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgreementById(agreementId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Agreement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgreementById(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.getAgreementById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *              Provides aggregated metrics (e.g., total balance, number of active agreements)             across all agreements accessible to the user.         
         * @summary Get aggregated summary across all agreements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgreementSummary(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Agreement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgreementSummary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.getAgreementSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all delivery attempts and responses for the specified webhook subscription.
         * @summary Fetch event logs for a webhook
         * @param {string} agreementId The ID of the agreement.
         * @param {string} webhookSettingsId The ID of the webhook subscription.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebhookLogs(agreementId: string, webhookSettingsId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebhookEventLog>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebhookLogs(agreementId, webhookSettingsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.getWebhookLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves every configured webhook subscriber for the given agreement.
         * @summary List all webhook subscriptions
         * @param {string} agreementId The ID of the agreement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWebhookSettings(agreementId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WebhookSubscriber>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWebhookSettings(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.getWebhookSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *              Grants specified permissions to a user on the given agreement.             Existing permissions for that user will be replaced.         
         * @summary Grant or update user access to an agreement
         * @param {string} agreementId The ID of the agreement to modify ACL for.
         * @param {AgreementMember} [agreementMember] The AgreementMember payload containing user ID, scopes, and contact info.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async grantAccessToAgreement(agreementId: string, agreementMember?: AgreementMember, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Agreement>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.grantAccessToAgreement(agreementId, agreementMember, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.grantAccessToAgreement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *              Returns a list of bank‐connection agreements for the requesting user.             Each agreement includes metadata such as creation date, status, and associated customer.         
         * @summary List all agreements visible to the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAgreements(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Agreement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAgreements(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.listAgreements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgreementApi - factory interface
 * @export
 */
export const AgreementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgreementApiFp(configuration)
    return {
        /**
         *              Adds plugin functionality (e.g., SFTP, ERP connectors) to the specified agreement.             The request body must include add-on name and configuration settings.         
         * @summary Install an add-on into an agreement
         * @param {string} agreementId The ID of the agreement to attach the add-on to.
         * @param {AddOnRequest} [addOnRequest] Payload specifying which add-on to install and its configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAddOn(agreementId: string, addOnRequest?: AddOnRequest, options?: AxiosRequestConfig): AxiosPromise<Agreement> {
            return localVarFp.createAddOn(agreementId, addOnRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetches detailed information about the specified agreement, including status and linked resources.
         * @summary Get a single agreement by its ID
         * @param {string} agreementId The UUID of the agreement to retrieve.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreementById(agreementId: string, options?: AxiosRequestConfig): AxiosPromise<Agreement> {
            return localVarFp.getAgreementById(agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         *              Provides aggregated metrics (e.g., total balance, number of active agreements)             across all agreements accessible to the user.         
         * @summary Get aggregated summary across all agreements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreementSummary(options?: AxiosRequestConfig): AxiosPromise<Agreement> {
            return localVarFp.getAgreementSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all delivery attempts and responses for the specified webhook subscription.
         * @summary Fetch event logs for a webhook
         * @param {string} agreementId The ID of the agreement.
         * @param {string} webhookSettingsId The ID of the webhook subscription.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookLogs(agreementId: string, webhookSettingsId: string, options?: AxiosRequestConfig): AxiosPromise<Array<WebhookEventLog>> {
            return localVarFp.getWebhookLogs(agreementId, webhookSettingsId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves every configured webhook subscriber for the given agreement.
         * @summary List all webhook subscriptions
         * @param {string} agreementId The ID of the agreement.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWebhookSettings(agreementId: string, options?: AxiosRequestConfig): AxiosPromise<Array<WebhookSubscriber>> {
            return localVarFp.getWebhookSettings(agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         *              Grants specified permissions to a user on the given agreement.             Existing permissions for that user will be replaced.         
         * @summary Grant or update user access to an agreement
         * @param {string} agreementId The ID of the agreement to modify ACL for.
         * @param {AgreementMember} [agreementMember] The AgreementMember payload containing user ID, scopes, and contact info.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        grantAccessToAgreement(agreementId: string, agreementMember?: AgreementMember, options?: AxiosRequestConfig): AxiosPromise<Agreement> {
            return localVarFp.grantAccessToAgreement(agreementId, agreementMember, options).then((request) => request(axios, basePath));
        },
        /**
         *              Returns a list of bank‐connection agreements for the requesting user.             Each agreement includes metadata such as creation date, status, and associated customer.         
         * @summary List all agreements visible to the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAgreements(options?: AxiosRequestConfig): AxiosPromise<Array<Agreement>> {
            return localVarFp.listAgreements(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgreementApi - object-oriented interface
 * @export
 * @class AgreementApi
 * @extends {BaseAPI}
 */
export class AgreementApi extends BaseAPI {
    /**
     *              Adds plugin functionality (e.g., SFTP, ERP connectors) to the specified agreement.             The request body must include add-on name and configuration settings.         
     * @summary Install an add-on into an agreement
     * @param {string} agreementId The ID of the agreement to attach the add-on to.
     * @param {AddOnRequest} [addOnRequest] Payload specifying which add-on to install and its configuration.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public createAddOn(agreementId: string, addOnRequest?: AddOnRequest, options?: AxiosRequestConfig) {
        return AgreementApiFp(this.configuration).createAddOn(agreementId, addOnRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetches detailed information about the specified agreement, including status and linked resources.
     * @summary Get a single agreement by its ID
     * @param {string} agreementId The UUID of the agreement to retrieve.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public getAgreementById(agreementId: string, options?: AxiosRequestConfig) {
        return AgreementApiFp(this.configuration).getAgreementById(agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *              Provides aggregated metrics (e.g., total balance, number of active agreements)             across all agreements accessible to the user.         
     * @summary Get aggregated summary across all agreements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public getAgreementSummary(options?: AxiosRequestConfig) {
        return AgreementApiFp(this.configuration).getAgreementSummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all delivery attempts and responses for the specified webhook subscription.
     * @summary Fetch event logs for a webhook
     * @param {string} agreementId The ID of the agreement.
     * @param {string} webhookSettingsId The ID of the webhook subscription.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public getWebhookLogs(agreementId: string, webhookSettingsId: string, options?: AxiosRequestConfig) {
        return AgreementApiFp(this.configuration).getWebhookLogs(agreementId, webhookSettingsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves every configured webhook subscriber for the given agreement.
     * @summary List all webhook subscriptions
     * @param {string} agreementId The ID of the agreement.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public getWebhookSettings(agreementId: string, options?: AxiosRequestConfig) {
        return AgreementApiFp(this.configuration).getWebhookSettings(agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *              Grants specified permissions to a user on the given agreement.             Existing permissions for that user will be replaced.         
     * @summary Grant or update user access to an agreement
     * @param {string} agreementId The ID of the agreement to modify ACL for.
     * @param {AgreementMember} [agreementMember] The AgreementMember payload containing user ID, scopes, and contact info.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public grantAccessToAgreement(agreementId: string, agreementMember?: AgreementMember, options?: AxiosRequestConfig) {
        return AgreementApiFp(this.configuration).grantAccessToAgreement(agreementId, agreementMember, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *              Returns a list of bank‐connection agreements for the requesting user.             Each agreement includes metadata such as creation date, status, and associated customer.         
     * @summary List all agreements visible to the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementApi
     */
    public listAgreements(options?: AxiosRequestConfig) {
        return AgreementApiFp(this.configuration).listAgreements(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approve an OAuth consent request.
         * @param {string} consentChallenge Consent challenge identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptConsentChallenge: async (consentChallenge: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentChallenge' is not null or undefined
            assertParamExists('acceptConsentChallenge', 'consentChallenge', consentChallenge)
            const localVarPath = `/auth/login/oauth/consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (consentChallenge !== undefined) {
                localVarQueryParameter['consentChallenge'] = consentChallenge;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve data required for OAuth consent screen.
         * @param {string} consentChallenge Consent challenge identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentData: async (consentChallenge: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'consentChallenge' is not null or undefined
            assertParamExists('getConsentData', 'consentChallenge', consentChallenge)
            const localVarPath = `/auth/login/oauth/consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (consentChallenge !== undefined) {
                localVarQueryParameter['consentChallenge'] = consentChallenge;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch the current user\'s session details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentSession: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Fetch pending invitations for the authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvites: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/invites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a list of supported authentication providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAuthProviders: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Authenticate a user using standard credentials.
         * @param {LoginRequest} loginRequest JSON payload containing authProvider, token, optional codeVerifier and redirectUri.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginRequest: LoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('login', 'loginRequest', loginRequest)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Initiate or complete OAuth-based login flow.
         * @param {string} state OAuth state or challenge value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithOauth: async (state: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('loginWithOauth', 'state', state)
            const localVarPath = `/auth/login/oauth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Process form-based Single Sign-On requests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithSSO: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/login/sso`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Authenticate a user via Single Sign-On SST token.
         * @param {string} token Secure Session Token (SST) value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithSST: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('loginWithSST', 'token', token)
            const localVarPath = `/auth/login/sst`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validate an email-based OTP or token for login.
         * @param {TokenLoginRequest} tokenLoginRequest Payload containing loginId and either OTP or token for authentication.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithToken: async (tokenLoginRequest: TokenLoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenLoginRequest' is not null or undefined
            assertParamExists('loginWithToken', 'tokenLoginRequest', tokenLoginRequest)
            const localVarPath = `/auth/login/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invalidate the current session and log out the user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send a one-time login link or OTP to a user\'s email.
         * @param {GetOtpRequest} getOtpRequest Specify recipient email and type to generate a magic login link.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestEmailToken: async (getOtpRequest: GetOtpRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getOtpRequest' is not null or undefined
            assertParamExists('requestEmailToken', 'getOtpRequest', getOtpRequest)
            const localVarPath = `/auth/token/email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getOtpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approve an OAuth consent request.
         * @param {string} consentChallenge Consent challenge identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptConsentChallenge(consentChallenge: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OauthState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptConsentChallenge(consentChallenge, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.acceptConsentChallenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve data required for OAuth consent screen.
         * @param {string} consentChallenge Consent challenge identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsentData(consentChallenge: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConsentData(consentChallenge, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.getConsentData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch the current user\'s session details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentSession(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentSession(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.getCurrentSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Fetch pending invitations for the authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getInvites(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Invite>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getInvites(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.getInvites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve a list of supported authentication providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAuthProviders(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AuthProviderResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAuthProviders(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.listAuthProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Authenticate a user using standard credentials.
         * @param {LoginRequest} loginRequest JSON payload containing authProvider, token, optional codeVerifier and redirectUri.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginRequest: LoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Initiate or complete OAuth-based login flow.
         * @param {string} state OAuth state or challenge value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginWithOauth(state: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OauthState>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginWithOauth(state, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.loginWithOauth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Process form-based Single Sign-On requests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginWithSSO(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginWithSSO(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.loginWithSSO']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Authenticate a user via Single Sign-On SST token.
         * @param {string} token Secure Session Token (SST) value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginWithSST(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginWithSST(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.loginWithSST']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Validate an email-based OTP or token for login.
         * @param {TokenLoginRequest} tokenLoginRequest Payload containing loginId and either OTP or token for authentication.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginWithToken(tokenLoginRequest: TokenLoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SessionData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginWithToken(tokenLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.loginWithToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Invalidate the current session and log out the user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logout(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.logout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send a one-time login link or OTP to a user\'s email.
         * @param {GetOtpRequest} getOtpRequest Specify recipient email and type to generate a magic login link.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestEmailToken(getOtpRequest: GetOtpRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOtpRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestEmailToken(getOtpRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.requestEmailToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @summary Approve an OAuth consent request.
         * @param {string} consentChallenge Consent challenge identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptConsentChallenge(consentChallenge: string, options?: AxiosRequestConfig): AxiosPromise<OauthState> {
            return localVarFp.acceptConsentChallenge(consentChallenge, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve data required for OAuth consent screen.
         * @param {string} consentChallenge Consent challenge identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentData(consentChallenge: string, options?: AxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getConsentData(consentChallenge, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch the current user\'s session details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentSession(options?: AxiosRequestConfig): AxiosPromise<SessionData> {
            return localVarFp.getCurrentSession(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Fetch pending invitations for the authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvites(options?: AxiosRequestConfig): AxiosPromise<Array<Invite>> {
            return localVarFp.getInvites(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a list of supported authentication providers.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAuthProviders(options?: AxiosRequestConfig): AxiosPromise<Array<AuthProviderResponse>> {
            return localVarFp.listAuthProviders(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Authenticate a user using standard credentials.
         * @param {LoginRequest} loginRequest JSON payload containing authProvider, token, optional codeVerifier and redirectUri.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginRequest: LoginRequest, options?: AxiosRequestConfig): AxiosPromise<SessionData> {
            return localVarFp.login(loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Initiate or complete OAuth-based login flow.
         * @param {string} state OAuth state or challenge value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithOauth(state: string, options?: AxiosRequestConfig): AxiosPromise<OauthState> {
            return localVarFp.loginWithOauth(state, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Process form-based Single Sign-On requests.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithSSO(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.loginWithSSO(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Authenticate a user via Single Sign-On SST token.
         * @param {string} token Secure Session Token (SST) value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithSST(token: string, options?: AxiosRequestConfig): AxiosPromise<SessionData> {
            return localVarFp.loginWithSST(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validate an email-based OTP or token for login.
         * @param {TokenLoginRequest} tokenLoginRequest Payload containing loginId and either OTP or token for authentication.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithToken(tokenLoginRequest: TokenLoginRequest, options?: AxiosRequestConfig): AxiosPromise<SessionData> {
            return localVarFp.loginWithToken(tokenLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invalidate the current session and log out the user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logout(options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.logout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send a one-time login link or OTP to a user\'s email.
         * @param {GetOtpRequest} getOtpRequest Specify recipient email and type to generate a magic login link.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestEmailToken(getOtpRequest: GetOtpRequest, options?: AxiosRequestConfig): AxiosPromise<GetOtpRequest> {
            return localVarFp.requestEmailToken(getOtpRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * 
     * @summary Approve an OAuth consent request.
     * @param {string} consentChallenge Consent challenge identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public acceptConsentChallenge(consentChallenge: string, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).acceptConsentChallenge(consentChallenge, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve data required for OAuth consent screen.
     * @param {string} consentChallenge Consent challenge identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public getConsentData(consentChallenge: string, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getConsentData(consentChallenge, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch the current user\'s session details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public getCurrentSession(options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getCurrentSession(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Fetch pending invitations for the authenticated user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public getInvites(options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getInvites(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a list of supported authentication providers.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public listAuthProviders(options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).listAuthProviders(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Authenticate a user using standard credentials.
     * @param {LoginRequest} loginRequest JSON payload containing authProvider, token, optional codeVerifier and redirectUri.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public login(loginRequest: LoginRequest, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).login(loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Initiate or complete OAuth-based login flow.
     * @param {string} state OAuth state or challenge value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public loginWithOauth(state: string, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).loginWithOauth(state, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Process form-based Single Sign-On requests.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public loginWithSSO(options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).loginWithSSO(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Authenticate a user via Single Sign-On SST token.
     * @param {string} token Secure Session Token (SST) value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public loginWithSST(token: string, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).loginWithSST(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Validate an email-based OTP or token for login.
     * @param {TokenLoginRequest} tokenLoginRequest Payload containing loginId and either OTP or token for authentication.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public loginWithToken(tokenLoginRequest: TokenLoginRequest, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).loginWithToken(tokenLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invalidate the current session and log out the user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public logout(options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).logout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send a one-time login link or OTP to a user\'s email.
     * @param {GetOtpRequest} getOtpRequest Specify recipient email and type to generate a magic login link.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public requestEmailToken(getOtpRequest: GetOtpRequest, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).requestEmailToken(getOtpRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContactApi - axios parameter creator
 * @export
 */
export const ContactApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Query contact list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryContacts: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactApi - functional programming interface
 * @export
 */
export const ContactApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Query contact list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async queryContacts(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Contact>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.queryContacts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactApi.queryContacts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContactApi - factory interface
 * @export
 */
export const ContactApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactApiFp(configuration)
    return {
        /**
         * 
         * @summary Query contact list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryContacts(options?: AxiosRequestConfig): AxiosPromise<Contact> {
            return localVarFp.queryContacts(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactApi - object-oriented interface
 * @export
 * @class ContactApi
 * @extends {BaseAPI}
 */
export class ContactApi extends BaseAPI {
    /**
     * 
     * @summary Query contact list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public queryContacts(options?: AxiosRequestConfig) {
        return ContactApiFp(this.configuration).queryContacts(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerApi - axios parameter creator
 * @export
 */
export const CustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get user profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerApi - functional programming interface
 * @export
 */
export const CustomerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get user profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfile(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.getProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerApi - factory interface
 * @export
 */
export const CustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerApiFp(configuration)
    return {
        /**
         * 
         * @summary Get user profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfile(options?: AxiosRequestConfig): AxiosPromise<Profile> {
            return localVarFp.getProfile(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
export class CustomerApi extends BaseAPI {
    /**
     * 
     * @summary Get user profile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getProfile(options?: AxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getProfile(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This endpoint returns a HTTP 200 status code if the server is up and running and accepting incoming requests.
         * @summary Check HTTP server status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAliveStatus: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health/alive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * This endpoint returns a HTTP 200 status code if the server is up and running and accepting incoming requests.
         * @summary Check HTTP server status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkAliveStatus(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkAliveStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.checkAliveStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * This endpoint returns a HTTP 200 status code if the server is up and running and accepting incoming requests.
         * @summary Check HTTP server status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkAliveStatus(options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.checkAliveStatus(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * This endpoint returns a HTTP 200 status code if the server is up and running and accepting incoming requests.
     * @summary Check HTTP server status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public checkAliveStatus(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).checkAliveStatus(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DeviceApi - axios parameter creator
 * @export
 */
export const DeviceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List devices for user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDevices: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/devices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeviceApi - functional programming interface
 * @export
 */
export const DeviceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeviceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List devices for user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDevices(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProvisionedDevice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDevices(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeviceApi.listDevices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeviceApi - factory interface
 * @export
 */
export const DeviceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeviceApiFp(configuration)
    return {
        /**
         * 
         * @summary List devices for user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDevices(options?: AxiosRequestConfig): AxiosPromise<Array<ProvisionedDevice>> {
            return localVarFp.listDevices(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeviceApi - object-oriented interface
 * @export
 * @class DeviceApi
 * @extends {BaseAPI}
 */
export class DeviceApi extends BaseAPI {
    /**
     * 
     * @summary List devices for user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeviceApi
     */
    public listDevices(options?: AxiosRequestConfig) {
        return DeviceApiFp(this.configuration).listDevices(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvoiceApi - axios parameter creator
 * @export
 */
export const InvoiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List invoices for selected account.
         * @param {string} accountNumber Account number
         * @param {string} [statusFilter] Comma-separated list of invoice statuses to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvoices: async (accountNumber: string, statusFilter?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountNumber' is not null or undefined
            assertParamExists('listInvoices', 'accountNumber', accountNumber)
            const localVarPath = `/accounts/{accountNumber}/invoices`
                .replace(`{${"accountNumber"}}`, encodeURIComponent(String(accountNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (statusFilter !== undefined) {
                localVarQueryParameter['statusFilter'] = statusFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sell invoice. Invoice must be registered in repository.
         * @param {string} accountNumber Account number
         * @param {Array<Invoice>} [invoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellInvoice: async (accountNumber: string, invoice?: Array<Invoice>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountNumber' is not null or undefined
            assertParamExists('sellInvoice', 'accountNumber', accountNumber)
            const localVarPath = `/accounts/{accountNumber}/invoices`
                .replace(`{${"accountNumber"}}`, encodeURIComponent(String(accountNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(invoice, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoiceApi - functional programming interface
 * @export
 */
export const InvoiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List invoices for selected account.
         * @param {string} accountNumber Account number
         * @param {string} [statusFilter] Comma-separated list of invoice statuses to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listInvoices(accountNumber: string, statusFilter?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Invoice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listInvoices(accountNumber, statusFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.listInvoices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sell invoice. Invoice must be registered in repository.
         * @param {string} accountNumber Account number
         * @param {Array<Invoice>} [invoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sellInvoice(accountNumber: string, invoice?: Array<Invoice>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Invoice>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sellInvoice(accountNumber, invoice, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvoiceApi.sellInvoice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvoiceApi - factory interface
 * @export
 */
export const InvoiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoiceApiFp(configuration)
    return {
        /**
         * 
         * @summary List invoices for selected account.
         * @param {string} accountNumber Account number
         * @param {string} [statusFilter] Comma-separated list of invoice statuses to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvoices(accountNumber: string, statusFilter?: string, options?: AxiosRequestConfig): AxiosPromise<Array<Invoice>> {
            return localVarFp.listInvoices(accountNumber, statusFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sell invoice. Invoice must be registered in repository.
         * @param {string} accountNumber Account number
         * @param {Array<Invoice>} [invoice] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sellInvoice(accountNumber: string, invoice?: Array<Invoice>, options?: AxiosRequestConfig): AxiosPromise<Array<Invoice>> {
            return localVarFp.sellInvoice(accountNumber, invoice, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoiceApi - object-oriented interface
 * @export
 * @class InvoiceApi
 * @extends {BaseAPI}
 */
export class InvoiceApi extends BaseAPI {
    /**
     * 
     * @summary List invoices for selected account.
     * @param {string} accountNumber Account number
     * @param {string} [statusFilter] Comma-separated list of invoice statuses to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public listInvoices(accountNumber: string, statusFilter?: string, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).listInvoices(accountNumber, statusFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sell invoice. Invoice must be registered in repository.
     * @param {string} accountNumber Account number
     * @param {Array<Invoice>} [invoice] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoiceApi
     */
    public sellInvoice(accountNumber: string, invoice?: Array<Invoice>, options?: AxiosRequestConfig) {
        return InvoiceApiFp(this.configuration).sellInvoice(accountNumber, invoice, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MerchantApi - axios parameter creator
 * @export
 */
export const MerchantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns merchant configuration data based on agreementId or merchantAlias
         * @summary Get merchant data
         * @param {string} [agreementId] Agreement ID
         * @param {string} [merchantAlias] Merchant alias
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantGet: async (agreementId?: string, merchantAlias?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/merchant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (agreementId !== undefined) {
                localVarQueryParameter['agreementId'] = agreementId;
            }

            if (merchantAlias !== undefined) {
                localVarQueryParameter['merchantAlias'] = merchantAlias;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MerchantApi - functional programming interface
 * @export
 */
export const MerchantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MerchantApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns merchant configuration data based on agreementId or merchantAlias
         * @summary Get merchant data
         * @param {string} [agreementId] Agreement ID
         * @param {string} [merchantAlias] Merchant alias
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async merchantGet(agreementId?: string, merchantAlias?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.merchantGet(agreementId, merchantAlias, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantApi.merchantGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MerchantApi - factory interface
 * @export
 */
export const MerchantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MerchantApiFp(configuration)
    return {
        /**
         * Returns merchant configuration data based on agreementId or merchantAlias
         * @summary Get merchant data
         * @param {string} [agreementId] Agreement ID
         * @param {string} [merchantAlias] Merchant alias
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merchantGet(agreementId?: string, merchantAlias?: string, options?: AxiosRequestConfig): AxiosPromise<MerchantData> {
            return localVarFp.merchantGet(agreementId, merchantAlias, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MerchantApi - object-oriented interface
 * @export
 * @class MerchantApi
 * @extends {BaseAPI}
 */
export class MerchantApi extends BaseAPI {
    /**
     * Returns merchant configuration data based on agreementId or merchantAlias
     * @summary Get merchant data
     * @param {string} [agreementId] Agreement ID
     * @param {string} [merchantAlias] Merchant alias
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MerchantApi
     */
    public merchantGet(agreementId?: string, merchantAlias?: string, options?: AxiosRequestConfig) {
        return MerchantApiFp(this.configuration).merchantGet(agreementId, merchantAlias, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MessagesApi - axios parameter creator
 * @export
 */
export const MessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns a letter in pdf format.
         * @summary Get a letter
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageFile: async (messageId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('getMessageFile', 'messageId', messageId)
            const localVarPath = `/message/{messageId}`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Messages are sent from our customer support and may include interest rate letters, price changes etc.
         * @summary List personal messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessages: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessagesApi - functional programming interface
 * @export
 */
export const MessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns a letter in pdf format.
         * @summary Get a letter
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessageFile(messageId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Message>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessageFile(messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesApi.getMessageFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Messages are sent from our customer support and may include interest rate letters, price changes etc.
         * @summary List personal messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMessages(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Message>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMessages(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessagesApi.listMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MessagesApi - factory interface
 * @export
 */
export const MessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessagesApiFp(configuration)
    return {
        /**
         * Returns a letter in pdf format.
         * @summary Get a letter
         * @param {string} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageFile(messageId: string, options?: AxiosRequestConfig): AxiosPromise<Array<Message>> {
            return localVarFp.getMessageFile(messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Messages are sent from our customer support and may include interest rate letters, price changes etc.
         * @summary List personal messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMessages(options?: AxiosRequestConfig): AxiosPromise<Array<Message>> {
            return localVarFp.listMessages(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MessagesApi - object-oriented interface
 * @export
 * @class MessagesApi
 * @extends {BaseAPI}
 */
export class MessagesApi extends BaseAPI {
    /**
     * Returns a letter in pdf format.
     * @summary Get a letter
     * @param {string} messageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public getMessageFile(messageId: string, options?: AxiosRequestConfig) {
        return MessagesApiFp(this.configuration).getMessageFile(messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Messages are sent from our customer support and may include interest rate letters, price changes etc.
     * @summary List personal messages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public listMessages(options?: AxiosRequestConfig) {
        return MessagesApiFp(this.configuration).listMessages(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationApi - axios parameter creator
 * @export
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Acknowledge notification received.
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeNotification: async (notificationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('acknowledgeNotification', 'notificationId', notificationId)
            const localVarPath = `/notifications/{notificationId}`
                .replace(`{${"notificationId"}}`, encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get notifications list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 * @export
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Acknowledge notification received.
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acknowledgeNotification(notificationId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppNotification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acknowledgeNotification(notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.acknowledgeNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get notifications list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotifications(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppNotification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotifications(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.getNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationApi - factory interface
 * @export
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiFp(configuration)
    return {
        /**
         * 
         * @summary Acknowledge notification received.
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acknowledgeNotification(notificationId: string, options?: AxiosRequestConfig): AxiosPromise<AppNotification> {
            return localVarFp.acknowledgeNotification(notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get notifications list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotifications(options?: AxiosRequestConfig): AxiosPromise<AppNotification> {
            return localVarFp.getNotifications(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
export class NotificationApi extends BaseAPI {
    /**
     * 
     * @summary Acknowledge notification received.
     * @param {string} notificationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public acknowledgeNotification(notificationId: string, options?: AxiosRequestConfig) {
        return NotificationApiFp(this.configuration).acknowledgeNotification(notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get notifications list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    public getNotifications(options?: AxiosRequestConfig) {
        return NotificationApiFp(this.configuration).getNotifications(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OauthApi - axios parameter creator
 * @export
 */
export const OauthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept login challenge.
         * @param {string} [loginChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptLoginChallenge: async (loginChallenge?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/oauth/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (loginChallenge !== undefined) {
                localVarQueryParameter['loginChallenge'] = loginChallenge;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Accept consent challenge.
         * @param {string} [consentChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptOAuthConsentChallenge: async (consentChallenge?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/oauth/consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (consentChallenge !== undefined) {
                localVarQueryParameter['consentChallenge'] = consentChallenge;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a pending oauth session.
         * @summary Get oauth session.
         * @param {string} [loginChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOauthSession: async (loginChallenge?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/oauth/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (loginChallenge !== undefined) {
                localVarQueryParameter['loginChallenge'] = loginChallenge;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OauthApi - functional programming interface
 * @export
 */
export const OauthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OauthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept login challenge.
         * @param {string} [loginChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptLoginChallenge(loginChallenge?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OauthSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptLoginChallenge(loginChallenge, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OauthApi.acceptLoginChallenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Accept consent challenge.
         * @param {string} [consentChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptOAuthConsentChallenge(consentChallenge?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OauthSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptOAuthConsentChallenge(consentChallenge, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OauthApi.acceptOAuthConsentChallenge']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a pending oauth session.
         * @summary Get oauth session.
         * @param {string} [loginChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOauthSession(loginChallenge?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OauthSession>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOauthSession(loginChallenge, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OauthApi.getOauthSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OauthApi - factory interface
 * @export
 */
export const OauthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OauthApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept login challenge.
         * @param {string} [loginChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptLoginChallenge(loginChallenge?: string, options?: AxiosRequestConfig): AxiosPromise<OauthSession> {
            return localVarFp.acceptLoginChallenge(loginChallenge, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Accept consent challenge.
         * @param {string} [consentChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptOAuthConsentChallenge(consentChallenge?: string, options?: AxiosRequestConfig): AxiosPromise<OauthSession> {
            return localVarFp.acceptOAuthConsentChallenge(consentChallenge, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a pending oauth session.
         * @summary Get oauth session.
         * @param {string} [loginChallenge] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOauthSession(loginChallenge?: string, options?: AxiosRequestConfig): AxiosPromise<OauthSession> {
            return localVarFp.getOauthSession(loginChallenge, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OauthApi - object-oriented interface
 * @export
 * @class OauthApi
 * @extends {BaseAPI}
 */
export class OauthApi extends BaseAPI {
    /**
     * 
     * @summary Accept login challenge.
     * @param {string} [loginChallenge] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OauthApi
     */
    public acceptLoginChallenge(loginChallenge?: string, options?: AxiosRequestConfig) {
        return OauthApiFp(this.configuration).acceptLoginChallenge(loginChallenge, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Accept consent challenge.
     * @param {string} [consentChallenge] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OauthApi
     */
    public acceptOAuthConsentChallenge(consentChallenge?: string, options?: AxiosRequestConfig) {
        return OauthApiFp(this.configuration).acceptOAuthConsentChallenge(consentChallenge, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a pending oauth session.
     * @summary Get oauth session.
     * @param {string} [loginChallenge] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OauthApi
     */
    public getOauthSession(loginChallenge?: string, options?: AxiosRequestConfig) {
        return OauthApiFp(this.configuration).getOauthSession(loginChallenge, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OnboardingApi - axios parameter creator
 * @export
 */
export const OnboardingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Start onboarding of new merchant.
         * @param {Array<StartOnboardingResponse>} [startOnboardingResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startOnboarding: async (startOnboardingResponse?: Array<StartOnboardingResponse>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/onboarding/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startOnboardingResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update onboarding of new merchant.
         * @param {Array<UpdateOnboardingRequest>} [updateOnboardingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOnboarding: async (updateOnboardingRequest?: Array<UpdateOnboardingRequest>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/onboarding/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOnboardingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnboardingApi - functional programming interface
 * @export
 */
export const OnboardingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnboardingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Start onboarding of new merchant.
         * @param {Array<StartOnboardingResponse>} [startOnboardingResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startOnboarding(startOnboardingResponse?: Array<StartOnboardingResponse>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StartOnboardingRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startOnboarding(startOnboardingResponse, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.startOnboarding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update onboarding of new merchant.
         * @param {Array<UpdateOnboardingRequest>} [updateOnboardingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOnboarding(updateOnboardingRequest?: Array<UpdateOnboardingRequest>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOnboardingRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOnboarding(updateOnboardingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OnboardingApi.updateOnboarding']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OnboardingApi - factory interface
 * @export
 */
export const OnboardingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnboardingApiFp(configuration)
    return {
        /**
         * 
         * @summary Start onboarding of new merchant.
         * @param {Array<StartOnboardingResponse>} [startOnboardingResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startOnboarding(startOnboardingResponse?: Array<StartOnboardingResponse>, options?: AxiosRequestConfig): AxiosPromise<StartOnboardingRequest> {
            return localVarFp.startOnboarding(startOnboardingResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update onboarding of new merchant.
         * @param {Array<UpdateOnboardingRequest>} [updateOnboardingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOnboarding(updateOnboardingRequest?: Array<UpdateOnboardingRequest>, options?: AxiosRequestConfig): AxiosPromise<UpdateOnboardingRequest> {
            return localVarFp.updateOnboarding(updateOnboardingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OnboardingApi - object-oriented interface
 * @export
 * @class OnboardingApi
 * @extends {BaseAPI}
 */
export class OnboardingApi extends BaseAPI {
    /**
     * 
     * @summary Start onboarding of new merchant.
     * @param {Array<StartOnboardingResponse>} [startOnboardingResponse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public startOnboarding(startOnboardingResponse?: Array<StartOnboardingResponse>, options?: AxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).startOnboarding(startOnboardingResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update onboarding of new merchant.
     * @param {Array<UpdateOnboardingRequest>} [updateOnboardingRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public updateOnboarding(updateOnboardingRequest?: Array<UpdateOnboardingRequest>, options?: AxiosRequestConfig) {
        return OnboardingApiFp(this.configuration).updateOnboarding(updateOnboardingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportApi - axios parameter creator
 * @export
 */
export const ReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get report for defined date interval for a given account.
         * @param {string} accountNumber Account number
         * @param {string} [fromDate] Report interval start date. Defaults to start of current month.
         * @param {string} [toDate] Report interval end date. Defaults to end of current month.
         * @param {string} [type] Report type.
         * @param {string} [format] Report format (XLSX, XLS, PDF). Defaults to XLSX
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport: async (accountNumber: string, fromDate?: string, toDate?: string, type?: string, format?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountNumber' is not null or undefined
            assertParamExists('getReport', 'accountNumber', accountNumber)
            const localVarPath = `/accounts/{accountNumber}/report`
                .replace(`{${"accountNumber"}}`, encodeURIComponent(String(accountNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportApi - functional programming interface
 * @export
 */
export const ReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get report for defined date interval for a given account.
         * @param {string} accountNumber Account number
         * @param {string} [fromDate] Report interval start date. Defaults to start of current month.
         * @param {string} [toDate] Report interval end date. Defaults to end of current month.
         * @param {string} [type] Report type.
         * @param {string} [format] Report format (XLSX, XLS, PDF). Defaults to XLSX
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReport(accountNumber: string, fromDate?: string, toDate?: string, type?: string, format?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReport(accountNumber, fromDate, toDate, type, format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportApi.getReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportApi - factory interface
 * @export
 */
export const ReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportApiFp(configuration)
    return {
        /**
         * 
         * @summary Get report for defined date interval for a given account.
         * @param {string} accountNumber Account number
         * @param {string} [fromDate] Report interval start date. Defaults to start of current month.
         * @param {string} [toDate] Report interval end date. Defaults to end of current month.
         * @param {string} [type] Report type.
         * @param {string} [format] Report format (XLSX, XLS, PDF). Defaults to XLSX
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReport(accountNumber: string, fromDate?: string, toDate?: string, type?: string, format?: string, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.getReport(accountNumber, fromDate, toDate, type, format, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportApi - object-oriented interface
 * @export
 * @class ReportApi
 * @extends {BaseAPI}
 */
export class ReportApi extends BaseAPI {
    /**
     * 
     * @summary Get report for defined date interval for a given account.
     * @param {string} accountNumber Account number
     * @param {string} [fromDate] Report interval start date. Defaults to start of current month.
     * @param {string} [toDate] Report interval end date. Defaults to end of current month.
     * @param {string} [type] Report type.
     * @param {string} [format] Report format (XLSX, XLS, PDF). Defaults to XLSX
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportApi
     */
    public getReport(accountNumber: string, fromDate?: string, toDate?: string, type?: string, format?: string, options?: AxiosRequestConfig) {
        return ReportApiFp(this.configuration).getReport(accountNumber, fromDate, toDate, type, format, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TaxDataApi - axios parameter creator
 * @export
 */
export const TaxDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get tax data for authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxData: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/taxdata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaxDataApi - functional programming interface
 * @export
 */
export const TaxDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaxDataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get tax data for authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaxData(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaxdataSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaxData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaxDataApi.getTaxData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TaxDataApi - factory interface
 * @export
 */
export const TaxDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaxDataApiFp(configuration)
    return {
        /**
         * 
         * @summary Get tax data for authenticated user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaxData(options?: AxiosRequestConfig): AxiosPromise<TaxdataSummary> {
            return localVarFp.getTaxData(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaxDataApi - object-oriented interface
 * @export
 * @class TaxDataApi
 * @extends {BaseAPI}
 */
export class TaxDataApi extends BaseAPI {
    /**
     * 
     * @summary Get tax data for authenticated user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaxDataApi
     */
    public getTaxData(options?: AxiosRequestConfig) {
        return TaxDataApiFp(this.configuration).getTaxData(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ThemesApi - axios parameter creator
 * @export
 */
export const ThemesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Fetch a single frontend application theme by id.
         * @summary Get a single theme by ID.
         * @param {string} themeId UUID of the theme.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThemeById: async (themeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'themeId' is not null or undefined
            assertParamExists('getThemeById', 'themeId', themeId)
            const localVarPath = `/themes/{themeId}`
                .replace(`{${"themeId"}}`, encodeURIComponent(String(themeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ThemesApi - functional programming interface
 * @export
 */
export const ThemesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ThemesApiAxiosParamCreator(configuration)
    return {
        /**
         * Fetch a single frontend application theme by id.
         * @summary Get a single theme by ID.
         * @param {string} themeId UUID of the theme.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getThemeById(themeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantTheme>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getThemeById(themeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThemesApi.getThemeById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ThemesApi - factory interface
 * @export
 */
export const ThemesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ThemesApiFp(configuration)
    return {
        /**
         * Fetch a single frontend application theme by id.
         * @summary Get a single theme by ID.
         * @param {string} themeId UUID of the theme.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThemeById(themeId: string, options?: AxiosRequestConfig): AxiosPromise<MerchantTheme> {
            return localVarFp.getThemeById(themeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ThemesApi - object-oriented interface
 * @export
 * @class ThemesApi
 * @extends {BaseAPI}
 */
export class ThemesApi extends BaseAPI {
    /**
     * Fetch a single frontend application theme by id.
     * @summary Get a single theme by ID.
     * @param {string} themeId UUID of the theme.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThemesApi
     */
    public getThemeById(themeId: string, options?: AxiosRequestConfig) {
        return ThemesApiFp(this.configuration).getThemeById(themeId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TransactionApi - axios parameter creator
 * @export
 */
export const TransactionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List transactions for a selected account.
         * @param {string} accountNumber Account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransactions: async (accountNumber: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountNumber' is not null or undefined
            assertParamExists('listTransactions', 'accountNumber', accountNumber)
            const localVarPath = `/accounts/{accountNumber}/transactions`
                .replace(`{${"accountNumber"}}`, encodeURIComponent(String(accountNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionApi - functional programming interface
 * @export
 */
export const TransactionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransactionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List transactions for a selected account.
         * @param {string} accountNumber Account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTransactions(accountNumber: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Transaction>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTransactions(accountNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionApi.listTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TransactionApi - factory interface
 * @export
 */
export const TransactionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransactionApiFp(configuration)
    return {
        /**
         * 
         * @summary List transactions for a selected account.
         * @param {string} accountNumber Account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTransactions(accountNumber: string, options?: AxiosRequestConfig): AxiosPromise<Array<Transaction>> {
            return localVarFp.listTransactions(accountNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransactionApi - object-oriented interface
 * @export
 * @class TransactionApi
 * @extends {BaseAPI}
 */
export class TransactionApi extends BaseAPI {
    /**
     * 
     * @summary List transactions for a selected account.
     * @param {string} accountNumber Account number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionApi
     */
    public listTransactions(accountNumber: string, options?: AxiosRequestConfig) {
        return TransactionApiFp(this.configuration).listTransactions(accountNumber, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get user profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get user profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserProfile(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary Get user profile.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile(options?: AxiosRequestConfig): AxiosPromise<Profile> {
            return localVarFp.getUserProfile(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary Get user profile.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getUserProfile(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getUserProfile(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VehicleApi - axios parameter creator
 * @export
 */
export const VehicleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get vehicle data from the national vehicle registry (SVV).
         * @param {string} [identifierType] Report interval start date. Defaults to start of current month.
         * @param {string} [identifier] Report interval start date. Defaults to start of current month.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleInfo: async (identifierType?: string, identifier?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vehicles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identifierType !== undefined) {
                localVarQueryParameter['identifierType'] = identifierType;
            }

            if (identifier !== undefined) {
                localVarQueryParameter['identifier'] = identifier;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VehicleApi - functional programming interface
 * @export
 */
export const VehicleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VehicleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get vehicle data from the national vehicle registry (SVV).
         * @param {string} [identifierType] Report interval start date. Defaults to start of current month.
         * @param {string} [identifier] Report interval start date. Defaults to start of current month.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVehicleInfo(identifierType?: string, identifier?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Vehicle>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVehicleInfo(identifierType, identifier, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VehicleApi.getVehicleInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VehicleApi - factory interface
 * @export
 */
export const VehicleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VehicleApiFp(configuration)
    return {
        /**
         * 
         * @summary Get vehicle data from the national vehicle registry (SVV).
         * @param {string} [identifierType] Report interval start date. Defaults to start of current month.
         * @param {string} [identifier] Report interval start date. Defaults to start of current month.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleInfo(identifierType?: string, identifier?: string, options?: AxiosRequestConfig): AxiosPromise<Vehicle> {
            return localVarFp.getVehicleInfo(identifierType, identifier, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VehicleApi - object-oriented interface
 * @export
 * @class VehicleApi
 * @extends {BaseAPI}
 */
export class VehicleApi extends BaseAPI {
    /**
     * 
     * @summary Get vehicle data from the national vehicle registry (SVV).
     * @param {string} [identifierType] Report interval start date. Defaults to start of current month.
     * @param {string} [identifier] Report interval start date. Defaults to start of current month.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VehicleApi
     */
    public getVehicleInfo(identifierType?: string, identifier?: string, options?: AxiosRequestConfig) {
        return VehicleApiFp(this.configuration).getVehicleInfo(identifierType, identifier, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VendorsApi - axios parameter creator
 * @export
 */
export const VendorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Compute the estimated price and fees for a proposed order under the specified agreement, based on payment method and order lines.
         * @summary Calculate pricing for an order.
         * @param {string} agreementId UUID of the agreement.
         * @param {Order} order Order payload containing product lines and payment method details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateOrderPrice: async (agreementId: string, order: Order, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('calculateOrderPrice', 'agreementId', agreementId)
            // verify required parameter 'order' is not null or undefined
            assertParamExists('calculateOrderPrice', 'order', order)
            const localVarPath = `/vendors/{agreementId}/orders/calculate`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(order, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mark the specified order as canceled under the given agreement.
         * @summary Cancel an existing order.
         * @param {string} agreementId UUID of the agreement.
         * @param {string} orderId UUID of the order to cancel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder: async (agreementId: string, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('cancelOrder', 'agreementId', agreementId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('cancelOrder', 'orderId', orderId)
            const localVarPath = `/vendors/{agreementId}/orders/{orderId}/cancel`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submit a new order under the specified agreement. Validates payment methods, order lines, and attachments.
         * @summary Create a new order.
         * @param {string} agreementId UUID of the agreement.
         * @param {Order} order Order payload with product lines, payment method, and optional attachments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrder: async (agreementId: string, order: Order, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('createOrder', 'agreementId', agreementId)
            // verify required parameter 'order' is not null or undefined
            assertParamExists('createOrder', 'order', order)
            const localVarPath = `/vendors/{agreementId}/orders`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(order, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch all accounts tied to the given agreement ID for the authenticated user.
         * @summary List accounts under a specific agreement.
         * @param {string} agreementId UUID of the agreement to retrieve accounts for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts: async (agreementId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getAccounts', 'agreementId', agreementId)
            const localVarPath = `/vendors/{agreementId}/accounts`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all agreement records (bank connections) associated with the authenticated user. Useful to see which agreements your organization has created.
         * @summary List all vendor agreements for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreements: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/vendors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Fetch detailed information for a specific order under the given agreement.
         * @summary Get a single order by ID.
         * @param {string} agreementId UUID of the agreement.
         * @param {string} orderId UUID of the order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderById: async (agreementId: string, orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getOrderById', 'agreementId', agreementId)
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getOrderById', 'orderId', orderId)
            const localVarPath = `/vendors/{agreementId}/orders/{orderId}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)))
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve orders created under the specified agreement. Supports pagination and filtering by status and date ranges.
         * @summary List orders for a specific agreement.
         * @param {string} agreementId UUID of the agreement to list orders for.
         * @param {string} [fromDate] Start of creation date range (ISO 8601).
         * @param {string} [toDate] End of creation date range (ISO 8601).
         * @param {string} [fromUpdateDate] Start of last update date range (ISO 8601).
         * @param {string} [toUpdateDate] End of last update date range (ISO 8601).
         * @param {number} [maxCount] Maximum number of orders to return (default 10).
         * @param {string} [nextPageToken] Token for pagination to fetch the next page.
         * @param {string} [statuses] Comma-separated list of order statuses to filter on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders: async (agreementId: string, fromDate?: string, toDate?: string, fromUpdateDate?: string, toUpdateDate?: string, maxCount?: number, nextPageToken?: string, statuses?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getOrders', 'agreementId', agreementId)
            const localVarPath = `/vendors/{agreementId}/orders`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (fromUpdateDate !== undefined) {
                localVarQueryParameter['fromUpdateDate'] = fromUpdateDate;
            }

            if (toUpdateDate !== undefined) {
                localVarQueryParameter['toUpdateDate'] = toUpdateDate;
            }

            if (maxCount !== undefined) {
                localVarQueryParameter['maxCount'] = maxCount;
            }

            if (nextPageToken !== undefined) {
                localVarQueryParameter['nextPageToken'] = nextPageToken;
            }

            if (statuses !== undefined) {
                localVarQueryParameter['statuses'] = statuses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Produce a financial report for the specified date range and report type under the agreement. Supports XLSX and PDF formats.
         * @summary Generate a usage report for a given agreement.
         * @param {string} agreementId UUID of the agreement.
         * @param {string} type Type of report to generate (e.g., SUMMARY, DETAILED).
         * @param {string} [fromDate] Report start date (ISO 8601). Defaults to first day of current month.
         * @param {string} [toDate] Report end date (ISO 8601). Defaults to last day of current month.
         * @param {string} [format] Output file format: XLSX or PDF. Defaults to XLSX.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorReport: async (agreementId: string, type: string, fromDate?: string, toDate?: string, format?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('getVendorReport', 'agreementId', agreementId)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getVendorReport', 'type', type)
            const localVarPath = `/vendors/{agreementId}/reports`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (fromDate !== undefined) {
                localVarQueryParameter['fromDate'] = fromDate;
            }

            if (toDate !== undefined) {
                localVarQueryParameter['toDate'] = toDate;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Store tax-related and risk assessment data for the specified order.
         * @summary Save tax and risk data for an order.
         * @param {string} orderId UUID of the order to update risk data for.
         * @param {string} body Risk data payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTaxData: async (orderId: string, body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('saveTaxData', 'orderId', orderId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('saveTaxData', 'body', body)
            const localVarPath = `/vendors/{agreementId}/orders/{orderId}/riskData`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify the details of an existing order by providing the updated order payload. As of now, only certain fields can be updated (dueDate).
         * @summary Update an existing order.
         * @param {string} orderId UUID of the order to update.
         * @param {Order} order Updated order payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrder: async (orderId: string, order: Order, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('updateOrder', 'orderId', orderId)
            // verify required parameter 'order' is not null or undefined
            assertParamExists('updateOrder', 'order', order)
            const localVarPath = `/vendors/{agreementId}/orders/{orderId}/`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(order, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modify the tax-related data for the specified order.
         * @summary Update tax data for an order.
         * @param {string} orderId UUID of the order to update tax data for.
         * @param {string} body Tax data payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaxData: async (orderId: string, body: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('updateTaxData', 'orderId', orderId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateTaxData', 'body', body)
            const localVarPath = `/vendors/{agreementId}/orders/{orderId}/taxData`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Attach a file (PDF, XLSX, etc.) to the specified order.
         * @summary Upload a file attachment to an order.
         * @param {string} orderId UUID of the order to attach the file to.
         * @param {OrderAttachment} orderAttachment Updated order payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment: async (orderId: string, orderAttachment: OrderAttachment, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('uploadAttachment', 'orderId', orderId)
            // verify required parameter 'orderAttachment' is not null or undefined
            assertParamExists('uploadAttachment', 'orderAttachment', orderAttachment)
            const localVarPath = `/vendors/{agreementId}/orders/{orderId}/attachment`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderAttachment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VendorsApi - functional programming interface
 * @export
 */
export const VendorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VendorsApiAxiosParamCreator(configuration)
    return {
        /**
         * Compute the estimated price and fees for a proposed order under the specified agreement, based on payment method and order lines.
         * @summary Calculate pricing for an order.
         * @param {string} agreementId UUID of the agreement.
         * @param {Order} order Order payload containing product lines and payment method details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateOrderPrice(agreementId: string, order: Order, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateOrderPrice(agreementId, order, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorsApi.calculateOrderPrice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Mark the specified order as canceled under the given agreement.
         * @summary Cancel an existing order.
         * @param {string} agreementId UUID of the agreement.
         * @param {string} orderId UUID of the order to cancel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelOrder(agreementId: string, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelOrder(agreementId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorsApi.cancelOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Submit a new order under the specified agreement. Validates payment methods, order lines, and attachments.
         * @summary Create a new order.
         * @param {string} agreementId UUID of the agreement.
         * @param {Order} order Order payload with product lines, payment method, and optional attachments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrder(agreementId: string, order: Order, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrder(agreementId, order, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorsApi.createOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch all accounts tied to the given agreement ID for the authenticated user.
         * @summary List accounts under a specific agreement.
         * @param {string} agreementId UUID of the agreement to retrieve accounts for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAccounts(agreementId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Account>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAccounts(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorsApi.getAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve all agreement records (bank connections) associated with the authenticated user. Useful to see which agreements your organization has created.
         * @summary List all vendor agreements for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgreements(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Agreement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgreements(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorsApi.getAgreements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Fetch detailed information for a specific order under the given agreement.
         * @summary Get a single order by ID.
         * @param {string} agreementId UUID of the agreement.
         * @param {string} orderId UUID of the order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrderById(agreementId: string, orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrderById(agreementId, orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorsApi.getOrderById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve orders created under the specified agreement. Supports pagination and filtering by status and date ranges.
         * @summary List orders for a specific agreement.
         * @param {string} agreementId UUID of the agreement to list orders for.
         * @param {string} [fromDate] Start of creation date range (ISO 8601).
         * @param {string} [toDate] End of creation date range (ISO 8601).
         * @param {string} [fromUpdateDate] Start of last update date range (ISO 8601).
         * @param {string} [toUpdateDate] End of last update date range (ISO 8601).
         * @param {number} [maxCount] Maximum number of orders to return (default 10).
         * @param {string} [nextPageToken] Token for pagination to fetch the next page.
         * @param {string} [statuses] Comma-separated list of order statuses to filter on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrders(agreementId: string, fromDate?: string, toDate?: string, fromUpdateDate?: string, toUpdateDate?: string, maxCount?: number, nextPageToken?: string, statuses?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Order>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrders(agreementId, fromDate, toDate, fromUpdateDate, toUpdateDate, maxCount, nextPageToken, statuses, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorsApi.getOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Produce a financial report for the specified date range and report type under the agreement. Supports XLSX and PDF formats.
         * @summary Generate a usage report for a given agreement.
         * @param {string} agreementId UUID of the agreement.
         * @param {string} type Type of report to generate (e.g., SUMMARY, DETAILED).
         * @param {string} [fromDate] Report start date (ISO 8601). Defaults to first day of current month.
         * @param {string} [toDate] Report end date (ISO 8601). Defaults to last day of current month.
         * @param {string} [format] Output file format: XLSX or PDF. Defaults to XLSX.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVendorReport(agreementId: string, type: string, fromDate?: string, toDate?: string, format?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVendorReport(agreementId, type, fromDate, toDate, format, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorsApi.getVendorReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Store tax-related and risk assessment data for the specified order.
         * @summary Save tax and risk data for an order.
         * @param {string} orderId UUID of the order to update risk data for.
         * @param {string} body Risk data payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTaxData(orderId: string, body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTaxData(orderId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorsApi.saveTaxData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify the details of an existing order by providing the updated order payload. As of now, only certain fields can be updated (dueDate).
         * @summary Update an existing order.
         * @param {string} orderId UUID of the order to update.
         * @param {Order} order Updated order payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOrder(orderId: string, order: Order, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Order>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOrder(orderId, order, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorsApi.updateOrder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Modify the tax-related data for the specified order.
         * @summary Update tax data for an order.
         * @param {string} orderId UUID of the order to update tax data for.
         * @param {string} body Tax data payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTaxData(orderId: string, body: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTaxData(orderId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorsApi.updateTaxData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Attach a file (PDF, XLSX, etc.) to the specified order.
         * @summary Upload a file attachment to an order.
         * @param {string} orderId UUID of the order to attach the file to.
         * @param {OrderAttachment} orderAttachment Updated order payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadAttachment(orderId: string, orderAttachment: OrderAttachment, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderAttachment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadAttachment(orderId, orderAttachment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VendorsApi.uploadAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VendorsApi - factory interface
 * @export
 */
export const VendorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VendorsApiFp(configuration)
    return {
        /**
         * Compute the estimated price and fees for a proposed order under the specified agreement, based on payment method and order lines.
         * @summary Calculate pricing for an order.
         * @param {string} agreementId UUID of the agreement.
         * @param {Order} order Order payload containing product lines and payment method details.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateOrderPrice(agreementId: string, order: Order, options?: AxiosRequestConfig): AxiosPromise<Order> {
            return localVarFp.calculateOrderPrice(agreementId, order, options).then((request) => request(axios, basePath));
        },
        /**
         * Mark the specified order as canceled under the given agreement.
         * @summary Cancel an existing order.
         * @param {string} agreementId UUID of the agreement.
         * @param {string} orderId UUID of the order to cancel.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelOrder(agreementId: string, orderId: string, options?: AxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.cancelOrder(agreementId, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Submit a new order under the specified agreement. Validates payment methods, order lines, and attachments.
         * @summary Create a new order.
         * @param {string} agreementId UUID of the agreement.
         * @param {Order} order Order payload with product lines, payment method, and optional attachments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrder(agreementId: string, order: Order, options?: AxiosRequestConfig): AxiosPromise<Order> {
            return localVarFp.createOrder(agreementId, order, options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch all accounts tied to the given agreement ID for the authenticated user.
         * @summary List accounts under a specific agreement.
         * @param {string} agreementId UUID of the agreement to retrieve accounts for.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts(agreementId: string, options?: AxiosRequestConfig): AxiosPromise<Array<Account>> {
            return localVarFp.getAccounts(agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all agreement records (bank connections) associated with the authenticated user. Useful to see which agreements your organization has created.
         * @summary List all vendor agreements for the current user.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgreements(options?: AxiosRequestConfig): AxiosPromise<Array<Agreement>> {
            return localVarFp.getAgreements(options).then((request) => request(axios, basePath));
        },
        /**
         * Fetch detailed information for a specific order under the given agreement.
         * @summary Get a single order by ID.
         * @param {string} agreementId UUID of the agreement.
         * @param {string} orderId UUID of the order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderById(agreementId: string, orderId: string, options?: AxiosRequestConfig): AxiosPromise<Order> {
            return localVarFp.getOrderById(agreementId, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve orders created under the specified agreement. Supports pagination and filtering by status and date ranges.
         * @summary List orders for a specific agreement.
         * @param {string} agreementId UUID of the agreement to list orders for.
         * @param {string} [fromDate] Start of creation date range (ISO 8601).
         * @param {string} [toDate] End of creation date range (ISO 8601).
         * @param {string} [fromUpdateDate] Start of last update date range (ISO 8601).
         * @param {string} [toUpdateDate] End of last update date range (ISO 8601).
         * @param {number} [maxCount] Maximum number of orders to return (default 10).
         * @param {string} [nextPageToken] Token for pagination to fetch the next page.
         * @param {string} [statuses] Comma-separated list of order statuses to filter on.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrders(agreementId: string, fromDate?: string, toDate?: string, fromUpdateDate?: string, toUpdateDate?: string, maxCount?: number, nextPageToken?: string, statuses?: string, options?: AxiosRequestConfig): AxiosPromise<Array<Order>> {
            return localVarFp.getOrders(agreementId, fromDate, toDate, fromUpdateDate, toUpdateDate, maxCount, nextPageToken, statuses, options).then((request) => request(axios, basePath));
        },
        /**
         * Produce a financial report for the specified date range and report type under the agreement. Supports XLSX and PDF formats.
         * @summary Generate a usage report for a given agreement.
         * @param {string} agreementId UUID of the agreement.
         * @param {string} type Type of report to generate (e.g., SUMMARY, DETAILED).
         * @param {string} [fromDate] Report start date (ISO 8601). Defaults to first day of current month.
         * @param {string} [toDate] Report end date (ISO 8601). Defaults to last day of current month.
         * @param {string} [format] Output file format: XLSX or PDF. Defaults to XLSX.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVendorReport(agreementId: string, type: string, fromDate?: string, toDate?: string, format?: string, options?: AxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getVendorReport(agreementId, type, fromDate, toDate, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Store tax-related and risk assessment data for the specified order.
         * @summary Save tax and risk data for an order.
         * @param {string} orderId UUID of the order to update risk data for.
         * @param {string} body Risk data payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTaxData(orderId: string, body: string, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.saveTaxData(orderId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify the details of an existing order by providing the updated order payload. As of now, only certain fields can be updated (dueDate).
         * @summary Update an existing order.
         * @param {string} orderId UUID of the order to update.
         * @param {Order} order Updated order payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrder(orderId: string, order: Order, options?: AxiosRequestConfig): AxiosPromise<Order> {
            return localVarFp.updateOrder(orderId, order, options).then((request) => request(axios, basePath));
        },
        /**
         * Modify the tax-related data for the specified order.
         * @summary Update tax data for an order.
         * @param {string} orderId UUID of the order to update tax data for.
         * @param {string} body Tax data payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTaxData(orderId: string, body: string, options?: AxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.updateTaxData(orderId, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Attach a file (PDF, XLSX, etc.) to the specified order.
         * @summary Upload a file attachment to an order.
         * @param {string} orderId UUID of the order to attach the file to.
         * @param {OrderAttachment} orderAttachment Updated order payload.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadAttachment(orderId: string, orderAttachment: OrderAttachment, options?: AxiosRequestConfig): AxiosPromise<OrderAttachment> {
            return localVarFp.uploadAttachment(orderId, orderAttachment, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VendorsApi - object-oriented interface
 * @export
 * @class VendorsApi
 * @extends {BaseAPI}
 */
export class VendorsApi extends BaseAPI {
    /**
     * Compute the estimated price and fees for a proposed order under the specified agreement, based on payment method and order lines.
     * @summary Calculate pricing for an order.
     * @param {string} agreementId UUID of the agreement.
     * @param {Order} order Order payload containing product lines and payment method details.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public calculateOrderPrice(agreementId: string, order: Order, options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).calculateOrderPrice(agreementId, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mark the specified order as canceled under the given agreement.
     * @summary Cancel an existing order.
     * @param {string} agreementId UUID of the agreement.
     * @param {string} orderId UUID of the order to cancel.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public cancelOrder(agreementId: string, orderId: string, options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).cancelOrder(agreementId, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submit a new order under the specified agreement. Validates payment methods, order lines, and attachments.
     * @summary Create a new order.
     * @param {string} agreementId UUID of the agreement.
     * @param {Order} order Order payload with product lines, payment method, and optional attachments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public createOrder(agreementId: string, order: Order, options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).createOrder(agreementId, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch all accounts tied to the given agreement ID for the authenticated user.
     * @summary List accounts under a specific agreement.
     * @param {string} agreementId UUID of the agreement to retrieve accounts for.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public getAccounts(agreementId: string, options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).getAccounts(agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve all agreement records (bank connections) associated with the authenticated user. Useful to see which agreements your organization has created.
     * @summary List all vendor agreements for the current user.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public getAgreements(options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).getAgreements(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Fetch detailed information for a specific order under the given agreement.
     * @summary Get a single order by ID.
     * @param {string} agreementId UUID of the agreement.
     * @param {string} orderId UUID of the order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public getOrderById(agreementId: string, orderId: string, options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).getOrderById(agreementId, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve orders created under the specified agreement. Supports pagination and filtering by status and date ranges.
     * @summary List orders for a specific agreement.
     * @param {string} agreementId UUID of the agreement to list orders for.
     * @param {string} [fromDate] Start of creation date range (ISO 8601).
     * @param {string} [toDate] End of creation date range (ISO 8601).
     * @param {string} [fromUpdateDate] Start of last update date range (ISO 8601).
     * @param {string} [toUpdateDate] End of last update date range (ISO 8601).
     * @param {number} [maxCount] Maximum number of orders to return (default 10).
     * @param {string} [nextPageToken] Token for pagination to fetch the next page.
     * @param {string} [statuses] Comma-separated list of order statuses to filter on.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public getOrders(agreementId: string, fromDate?: string, toDate?: string, fromUpdateDate?: string, toUpdateDate?: string, maxCount?: number, nextPageToken?: string, statuses?: string, options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).getOrders(agreementId, fromDate, toDate, fromUpdateDate, toUpdateDate, maxCount, nextPageToken, statuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Produce a financial report for the specified date range and report type under the agreement. Supports XLSX and PDF formats.
     * @summary Generate a usage report for a given agreement.
     * @param {string} agreementId UUID of the agreement.
     * @param {string} type Type of report to generate (e.g., SUMMARY, DETAILED).
     * @param {string} [fromDate] Report start date (ISO 8601). Defaults to first day of current month.
     * @param {string} [toDate] Report end date (ISO 8601). Defaults to last day of current month.
     * @param {string} [format] Output file format: XLSX or PDF. Defaults to XLSX.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public getVendorReport(agreementId: string, type: string, fromDate?: string, toDate?: string, format?: string, options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).getVendorReport(agreementId, type, fromDate, toDate, format, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Store tax-related and risk assessment data for the specified order.
     * @summary Save tax and risk data for an order.
     * @param {string} orderId UUID of the order to update risk data for.
     * @param {string} body Risk data payload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public saveTaxData(orderId: string, body: string, options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).saveTaxData(orderId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Modify the details of an existing order by providing the updated order payload. As of now, only certain fields can be updated (dueDate).
     * @summary Update an existing order.
     * @param {string} orderId UUID of the order to update.
     * @param {Order} order Updated order payload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public updateOrder(orderId: string, order: Order, options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).updateOrder(orderId, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Modify the tax-related data for the specified order.
     * @summary Update tax data for an order.
     * @param {string} orderId UUID of the order to update tax data for.
     * @param {string} body Tax data payload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public updateTaxData(orderId: string, body: string, options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).updateTaxData(orderId, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Attach a file (PDF, XLSX, etc.) to the specified order.
     * @summary Upload a file attachment to an order.
     * @param {string} orderId UUID of the order to attach the file to.
     * @param {OrderAttachment} orderAttachment Updated order payload.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public uploadAttachment(orderId: string, orderAttachment: OrderAttachment, options?: AxiosRequestConfig) {
        return VendorsApiFp(this.configuration).uploadAttachment(orderId, orderAttachment, options).then((request) => request(this.axios, this.basePath));
    }
}



